var map = {
	"./banjo-and-kazooie/avatar0.png": "b2a2",
	"./banjo-and-kazooie/avatar1.png": "fa01",
	"./banjo-and-kazooie/avatar2.png": "6a0a",
	"./banjo-and-kazooie/avatar3.png": "4e17",
	"./banjo-and-kazooie/avatar4.png": "57fb",
	"./banjo-and-kazooie/avatar5.png": "06d5",
	"./banjo-and-kazooie/avatar6.png": "4d5e2",
	"./banjo-and-kazooie/avatar7.png": "5c48",
	"./banjo-and-kazooie/full0-min.png": "d43c",
	"./banjo-and-kazooie/full1-min.png": "8620",
	"./banjo-and-kazooie/full2-min.png": "6d72",
	"./banjo-and-kazooie/full3-min.png": "65cd",
	"./banjo-and-kazooie/full4-min.png": "6f53",
	"./banjo-and-kazooie/full5-min.png": "718e",
	"./banjo-and-kazooie/full6-min.png": "6144",
	"./banjo-and-kazooie/full7-min.png": "21d8",
	"./banjo-and-kazooie/selected0-min.png": "8db3",
	"./banjo-and-kazooie/selected1-min.png": "0d11",
	"./banjo-and-kazooie/selected2-min.png": "ae35",
	"./banjo-and-kazooie/selected3-min.png": "967e",
	"./banjo-and-kazooie/selected4-min.png": "5494",
	"./banjo-and-kazooie/selected5-min.png": "4ba1",
	"./banjo-and-kazooie/selected6-min.png": "7954",
	"./banjo-and-kazooie/selected7-min.png": "14ba",
	"./banjo-and-kazooie/stock0.png": "e7df",
	"./banjo-and-kazooie/stock1.png": "ef03",
	"./banjo-and-kazooie/stock2.png": "fdfb",
	"./banjo-and-kazooie/stock3.png": "ab92",
	"./banjo-and-kazooie/stock4.png": "56c9",
	"./banjo-and-kazooie/stock5.png": "46a0",
	"./banjo-and-kazooie/stock6.png": "4cf9",
	"./banjo-and-kazooie/stock7.png": "ab33",
	"./bayonetta/avatar0.png": "87f3",
	"./bayonetta/avatar1.png": "849a",
	"./bayonetta/avatar2.png": "a3a9",
	"./bayonetta/avatar3.png": "1de4",
	"./bayonetta/avatar4.png": "791b",
	"./bayonetta/avatar5.png": "f801",
	"./bayonetta/avatar6.png": "fb8c",
	"./bayonetta/avatar7.png": "d2e4",
	"./bayonetta/full0-min.png": "1dac",
	"./bayonetta/full1-min.png": "9adb",
	"./bayonetta/full2-min.png": "9ee0",
	"./bayonetta/full3-min.png": "e607",
	"./bayonetta/full4-min.png": "5349",
	"./bayonetta/full5-min.png": "889b",
	"./bayonetta/full6-min.png": "136c",
	"./bayonetta/full7-min.png": "f9f2",
	"./bayonetta/selected0-min.png": "db9e",
	"./bayonetta/selected1-min.png": "8350",
	"./bayonetta/selected2-min.png": "6915",
	"./bayonetta/selected3-min.png": "290c",
	"./bayonetta/selected4-min.png": "2c7d",
	"./bayonetta/selected5-min.png": "1271",
	"./bayonetta/selected6-min.png": "ee06",
	"./bayonetta/selected7-min.png": "d464",
	"./bayonetta/stock0.png": "a4eb",
	"./bayonetta/stock1.png": "d299",
	"./bayonetta/stock2.png": "3fb3",
	"./bayonetta/stock3.png": "03e4",
	"./bayonetta/stock4.png": "75a4",
	"./bayonetta/stock5.png": "b8c4",
	"./bayonetta/stock6.png": "c4f2",
	"./bayonetta/stock7.png": "007d",
	"./bowser-jr/avatar0.png": "6974",
	"./bowser-jr/avatar1.png": "74bb",
	"./bowser-jr/avatar2.png": "13e9",
	"./bowser-jr/avatar3.png": "5ec8",
	"./bowser-jr/avatar4.png": "b9ea",
	"./bowser-jr/avatar5.png": "3853",
	"./bowser-jr/avatar6.png": "81a5",
	"./bowser-jr/avatar7.png": "44b2",
	"./bowser-jr/full0-min.png": "ecfc",
	"./bowser-jr/full1-min.png": "101a",
	"./bowser-jr/full2-min.png": "8111",
	"./bowser-jr/full3-min.png": "aff5",
	"./bowser-jr/full4-min.png": "a61b",
	"./bowser-jr/full5-min.png": "843f",
	"./bowser-jr/full6-min.png": "8e31",
	"./bowser-jr/full7-min.png": "f18b",
	"./bowser-jr/selected0-min.png": "1ebd",
	"./bowser-jr/selected1-min.png": "ad69",
	"./bowser-jr/selected2-min.png": "6f16",
	"./bowser-jr/selected3-min.png": "b6c2",
	"./bowser-jr/selected4-min.png": "f146",
	"./bowser-jr/selected5-min.png": "8844",
	"./bowser-jr/selected6-min.png": "8a31",
	"./bowser-jr/selected7-min.png": "f4fc",
	"./bowser-jr/stock0.png": "727f",
	"./bowser-jr/stock1.png": "06c0",
	"./bowser-jr/stock2.png": "ac3f",
	"./bowser-jr/stock3.png": "5aea",
	"./bowser-jr/stock4.png": "c9d8",
	"./bowser-jr/stock5.png": "5de0",
	"./bowser-jr/stock6.png": "09be",
	"./bowser-jr/stock7.png": "452f",
	"./bowser/avatar0.png": "6512",
	"./bowser/avatar1.png": "564c",
	"./bowser/avatar2.png": "5427",
	"./bowser/avatar3.png": "00a8",
	"./bowser/avatar4.png": "729d",
	"./bowser/avatar5.png": "9879",
	"./bowser/avatar6.png": "1b5d",
	"./bowser/avatar7.png": "6472",
	"./bowser/full0-min.png": "6f94",
	"./bowser/full1-min.png": "c700",
	"./bowser/full2-min.png": "000e",
	"./bowser/full3-min.png": "4809",
	"./bowser/full4-min.png": "67cf",
	"./bowser/full5-min.png": "ea86",
	"./bowser/full6-min.png": "e9cc",
	"./bowser/full7-min.png": "6a01",
	"./bowser/selected0-min.png": "9a55",
	"./bowser/selected1-min.png": "b413",
	"./bowser/selected2-min.png": "36b9",
	"./bowser/selected3-min.png": "4afb",
	"./bowser/selected4-min.png": "3807",
	"./bowser/selected5-min.png": "bf27",
	"./bowser/selected6-min.png": "d30c",
	"./bowser/selected7-min.png": "a8c0",
	"./bowser/stock0.png": "c8ce",
	"./bowser/stock1.png": "2923",
	"./bowser/stock2.png": "2c69",
	"./bowser/stock3.png": "7a6c",
	"./bowser/stock4.png": "5455",
	"./bowser/stock5.png": "78ce",
	"./bowser/stock6.png": "4aef",
	"./bowser/stock7.png": "c7bb",
	"./byleth/avatar0.png": "e0be",
	"./byleth/avatar1.png": "9329",
	"./byleth/avatar2.png": "0abc",
	"./byleth/avatar3.png": "b869",
	"./byleth/avatar4.png": "1b06d",
	"./byleth/avatar5.png": "18ea",
	"./byleth/avatar6.png": "5790",
	"./byleth/avatar7.png": "0d11e",
	"./byleth/full0-min.png": "6efd",
	"./byleth/full1-min.png": "777f",
	"./byleth/full2-min.png": "39b8",
	"./byleth/full3-min.png": "37e6",
	"./byleth/full4-min.png": "c1f2",
	"./byleth/full5-min.png": "94c4",
	"./byleth/full6-min.png": "4d1a",
	"./byleth/full7-min.png": "0773",
	"./byleth/selected0-min.png": "7570",
	"./byleth/selected1-min.png": "4db5",
	"./byleth/selected2-min.png": "fd00",
	"./byleth/selected3-min.png": "f6d9",
	"./byleth/selected4-min.png": "8ecb",
	"./byleth/selected5-min.png": "3b2d",
	"./byleth/selected6-min.png": "7b39",
	"./byleth/selected7-min.png": "532a",
	"./byleth/stock0.png": "52e4",
	"./byleth/stock1.png": "d732",
	"./byleth/stock2.png": "aabb",
	"./byleth/stock3.png": "6e78",
	"./byleth/stock4.png": "55b3",
	"./byleth/stock5.png": "0f33",
	"./byleth/stock6.png": "9a49",
	"./byleth/stock7.png": "ddce",
	"./captain-falcon/avatar0.png": "8f4a",
	"./captain-falcon/avatar1.png": "8ee5",
	"./captain-falcon/avatar2.png": "f2e7",
	"./captain-falcon/avatar3.png": "3b0c",
	"./captain-falcon/avatar4.png": "a688",
	"./captain-falcon/avatar5.png": "7093",
	"./captain-falcon/avatar6.png": "65e3",
	"./captain-falcon/avatar7.png": "c638",
	"./captain-falcon/full0-min.png": "4239",
	"./captain-falcon/full1-min.png": "eb44",
	"./captain-falcon/full2-min.png": "e1aa",
	"./captain-falcon/full3-min.png": "6bcc",
	"./captain-falcon/full4-min.png": "b1a4",
	"./captain-falcon/full5-min.png": "41ca",
	"./captain-falcon/full6-min.png": "8a31c",
	"./captain-falcon/full7-min.png": "03e3",
	"./captain-falcon/selected0-min.png": "d38a",
	"./captain-falcon/selected1-min.png": "9476",
	"./captain-falcon/selected2-min.png": "3662",
	"./captain-falcon/selected3-min.png": "bd07",
	"./captain-falcon/selected4-min.png": "0d92",
	"./captain-falcon/selected5-min.png": "59e6",
	"./captain-falcon/selected6-min.png": "cdea",
	"./captain-falcon/selected7-min.png": "1183",
	"./captain-falcon/stock0.png": "2438",
	"./captain-falcon/stock1.png": "6e9b",
	"./captain-falcon/stock2.png": "749f",
	"./captain-falcon/stock3.png": "7ebe",
	"./captain-falcon/stock4.png": "4c50",
	"./captain-falcon/stock5.png": "10c4",
	"./captain-falcon/stock6.png": "5828",
	"./captain-falcon/stock7.png": "ba46",
	"./chrom/avatar0.png": "e4d1",
	"./chrom/avatar1.png": "09f0",
	"./chrom/avatar2.png": "75a9",
	"./chrom/avatar3.png": "a28f",
	"./chrom/avatar4.png": "05d4",
	"./chrom/avatar5.png": "b9bd",
	"./chrom/avatar6.png": "c2d9",
	"./chrom/avatar7.png": "2fd5",
	"./chrom/full0-min.png": "4741",
	"./chrom/full1-min.png": "1e9b",
	"./chrom/full2-min.png": "53ab",
	"./chrom/full3-min.png": "ada6",
	"./chrom/full4-min.png": "63d9",
	"./chrom/full5-min.png": "a2eb",
	"./chrom/full6-min.png": "279d",
	"./chrom/full7-min.png": "c9ca",
	"./chrom/selected0-min.png": "53cb",
	"./chrom/selected1-min.png": "e013",
	"./chrom/selected2-min.png": "ff2a",
	"./chrom/selected3-min.png": "800f",
	"./chrom/selected4-min.png": "1ad0",
	"./chrom/selected5-min.png": "df6d",
	"./chrom/selected6-min.png": "59e9",
	"./chrom/selected7-min.png": "f571",
	"./chrom/stock0.png": "b86d6",
	"./chrom/stock1.png": "defb2",
	"./chrom/stock2.png": "2635",
	"./chrom/stock3.png": "5bed",
	"./chrom/stock4.png": "d292",
	"./chrom/stock5.png": "eec6",
	"./chrom/stock6.png": "6335",
	"./chrom/stock7.png": "355d",
	"./cloud/avatar0.png": "9f8c",
	"./cloud/avatar1.png": "9417",
	"./cloud/avatar2.png": "6439",
	"./cloud/avatar3.png": "9ec0",
	"./cloud/avatar4.png": "1bb0",
	"./cloud/avatar5.png": "172b",
	"./cloud/avatar6.png": "1365",
	"./cloud/avatar7.png": "9edd",
	"./cloud/full0-min.png": "637d",
	"./cloud/full1-min.png": "70f4",
	"./cloud/full2-min.png": "9e61",
	"./cloud/full3-min.png": "0fe5",
	"./cloud/full4-min.png": "cbb7",
	"./cloud/full5-min.png": "5b64",
	"./cloud/full6-min.png": "0bc6",
	"./cloud/full7-min.png": "5531",
	"./cloud/selected0-min.png": "45a5",
	"./cloud/selected1-min.png": "c38a",
	"./cloud/selected2-min.png": "5d02",
	"./cloud/selected3-min.png": "f0c0",
	"./cloud/selected4-min.png": "74df",
	"./cloud/selected5-min.png": "66f7",
	"./cloud/selected6-min.png": "e253",
	"./cloud/selected7-min.png": "952f",
	"./cloud/stock0.png": "1e9c",
	"./cloud/stock1.png": "0152",
	"./cloud/stock2.png": "2006",
	"./cloud/stock3.png": "382f0",
	"./cloud/stock4.png": "7dc0",
	"./cloud/stock5.png": "6203",
	"./cloud/stock6.png": "24e0",
	"./cloud/stock7.png": "8dfa",
	"./corrin/avatar0.png": "c9e6",
	"./corrin/avatar1.png": "9da7",
	"./corrin/avatar2.png": "4809c",
	"./corrin/avatar3.png": "1f06",
	"./corrin/avatar4.png": "ed36",
	"./corrin/avatar5.png": "9238",
	"./corrin/avatar6.png": "10db",
	"./corrin/avatar7.png": "9468",
	"./corrin/full0-min.png": "3873",
	"./corrin/full1-min.png": "e11e",
	"./corrin/full2-min.png": "1190",
	"./corrin/full3-min.png": "71fa",
	"./corrin/full4-min.png": "c577",
	"./corrin/full5-min.png": "86d4",
	"./corrin/full6-min.png": "898e",
	"./corrin/full7-min.png": "5c63",
	"./corrin/selected0-min.png": "5f55",
	"./corrin/selected1-min.png": "086c",
	"./corrin/selected2-min.png": "d9c2",
	"./corrin/selected3-min.png": "6db6",
	"./corrin/selected4-min.png": "ee81",
	"./corrin/selected5-min.png": "ec10",
	"./corrin/selected6-min.png": "c0fa",
	"./corrin/selected7-min.png": "6183",
	"./corrin/stock0.png": "72e2",
	"./corrin/stock1.png": "0adc",
	"./corrin/stock2.png": "a6d8",
	"./corrin/stock3.png": "3898",
	"./corrin/stock4.png": "13b1",
	"./corrin/stock5.png": "e980",
	"./corrin/stock6.png": "e584",
	"./corrin/stock7.png": "0bb2",
	"./daisy/avatar0.png": "d6c9",
	"./daisy/avatar1.png": "9f8c3",
	"./daisy/avatar2.png": "91ae",
	"./daisy/avatar3.png": "2113",
	"./daisy/avatar4.png": "d8ce6",
	"./daisy/avatar5.png": "bd2e",
	"./daisy/avatar6.png": "1b96",
	"./daisy/avatar7.png": "fe6d",
	"./daisy/full0-min.png": "c61f",
	"./daisy/full1-min.png": "2dac",
	"./daisy/full2-min.png": "5e29",
	"./daisy/full3-min.png": "5770",
	"./daisy/full4-min.png": "5c43",
	"./daisy/full5-min.png": "12a0",
	"./daisy/full6-min.png": "1b06",
	"./daisy/full7-min.png": "87a1",
	"./daisy/selected0-min.png": "0122",
	"./daisy/selected1-min.png": "491e",
	"./daisy/selected2-min.png": "285f",
	"./daisy/selected3-min.png": "659a",
	"./daisy/selected4-min.png": "cfed",
	"./daisy/selected5-min.png": "8e35",
	"./daisy/selected6-min.png": "8b98",
	"./daisy/selected7-min.png": "ae06",
	"./daisy/stock0.png": "e84a",
	"./daisy/stock1.png": "741a",
	"./daisy/stock2.png": "5897",
	"./daisy/stock3.png": "823d",
	"./daisy/stock4.png": "e6c7",
	"./daisy/stock5.png": "1070",
	"./daisy/stock6.png": "f83f",
	"./daisy/stock7.png": "b974",
	"./dark-pit/avatar0.png": "6399",
	"./dark-pit/avatar1.png": "babb",
	"./dark-pit/avatar2.png": "cf6b",
	"./dark-pit/avatar3.png": "dbb8",
	"./dark-pit/avatar4.png": "76d2",
	"./dark-pit/avatar5.png": "0af8",
	"./dark-pit/avatar6.png": "4b17",
	"./dark-pit/avatar7.png": "7232",
	"./dark-pit/full0-min.png": "5df0",
	"./dark-pit/full1-min.png": "db91",
	"./dark-pit/full2-min.png": "e651",
	"./dark-pit/full3-min.png": "0e06",
	"./dark-pit/full4-min.png": "252c",
	"./dark-pit/full5-min.png": "4477",
	"./dark-pit/full6-min.png": "4775",
	"./dark-pit/full7-min.png": "b886",
	"./dark-pit/selected0-min.png": "1e4f",
	"./dark-pit/selected1-min.png": "b39c",
	"./dark-pit/selected2-min.png": "345d",
	"./dark-pit/selected3-min.png": "7112",
	"./dark-pit/selected4-min.png": "00ec",
	"./dark-pit/selected5-min.png": "ca02",
	"./dark-pit/selected6-min.png": "c2bf",
	"./dark-pit/selected7-min.png": "ffb8",
	"./dark-pit/stock0.png": "fcdf",
	"./dark-pit/stock1.png": "91e6",
	"./dark-pit/stock2.png": "9ba1",
	"./dark-pit/stock3.png": "0e3d",
	"./dark-pit/stock4.png": "84af",
	"./dark-pit/stock5.png": "89d5",
	"./dark-pit/stock6.png": "f696a",
	"./dark-pit/stock7.png": "9387",
	"./dark-samus/avatar0.png": "b466",
	"./dark-samus/avatar1.png": "5400",
	"./dark-samus/avatar2.png": "7293",
	"./dark-samus/avatar3.png": "3e36",
	"./dark-samus/avatar4.png": "d66a",
	"./dark-samus/avatar5.png": "527f",
	"./dark-samus/avatar6.png": "6982",
	"./dark-samus/avatar7.png": "c333",
	"./dark-samus/full0-min.png": "73e2",
	"./dark-samus/full1-min.png": "a6e5",
	"./dark-samus/full2-min.png": "4b3e",
	"./dark-samus/full3-min.png": "5229",
	"./dark-samus/full4-min.png": "f696",
	"./dark-samus/full5-min.png": "7530",
	"./dark-samus/full6-min.png": "dcd6",
	"./dark-samus/full7-min.png": "cba9",
	"./dark-samus/selected0-min.png": "bbd7",
	"./dark-samus/selected1-min.png": "e8bb",
	"./dark-samus/selected2-min.png": "f42b",
	"./dark-samus/selected3-min.png": "e125",
	"./dark-samus/selected4-min.png": "4232",
	"./dark-samus/selected5-min.png": "301e",
	"./dark-samus/selected6-min.png": "0201",
	"./dark-samus/selected7-min.png": "cf88",
	"./dark-samus/stock0.png": "fa9b",
	"./dark-samus/stock1.png": "0fc3",
	"./dark-samus/stock2.png": "e9b6",
	"./dark-samus/stock3.png": "1655",
	"./dark-samus/stock4.png": "fb70",
	"./dark-samus/stock5.png": "dc31",
	"./dark-samus/stock6.png": "c06f",
	"./dark-samus/stock7.png": "414f",
	"./diddy-kong/avatar0.png": "d1ae",
	"./diddy-kong/avatar1.png": "8d15",
	"./diddy-kong/avatar2.png": "d484",
	"./diddy-kong/avatar3.png": "fa67",
	"./diddy-kong/avatar4.png": "b17f",
	"./diddy-kong/avatar5.png": "6693",
	"./diddy-kong/avatar6.png": "87ed",
	"./diddy-kong/avatar7.png": "4305",
	"./diddy-kong/full0-min.png": "877d",
	"./diddy-kong/full1-min.png": "81e4",
	"./diddy-kong/full2-min.png": "6c90",
	"./diddy-kong/full3-min.png": "cff2",
	"./diddy-kong/full4-min.png": "018d",
	"./diddy-kong/full5-min.png": "dd3c",
	"./diddy-kong/full6-min.png": "2b1e",
	"./diddy-kong/full7-min.png": "02ba",
	"./diddy-kong/selected0-min.png": "d7e1",
	"./diddy-kong/selected1-min.png": "9c40",
	"./diddy-kong/selected2-min.png": "9be3",
	"./diddy-kong/selected3-min.png": "d8fe",
	"./diddy-kong/selected4-min.png": "7d82",
	"./diddy-kong/selected5-min.png": "a8f3",
	"./diddy-kong/selected6-min.png": "2dbd",
	"./diddy-kong/selected7-min.png": "b986",
	"./diddy-kong/stock0.png": "535b",
	"./diddy-kong/stock1.png": "fec0",
	"./diddy-kong/stock2.png": "335d",
	"./diddy-kong/stock3.png": "fa54",
	"./diddy-kong/stock4.png": "f0ed",
	"./diddy-kong/stock5.png": "21fd",
	"./diddy-kong/stock6.png": "ef73",
	"./diddy-kong/stock7.png": "42d0",
	"./donkey-kong/avatar0.png": "8cfe",
	"./donkey-kong/avatar1.png": "5904",
	"./donkey-kong/avatar2.png": "9e1f",
	"./donkey-kong/avatar3.png": "46f0",
	"./donkey-kong/avatar4.png": "c2c8",
	"./donkey-kong/avatar5.png": "3da1",
	"./donkey-kong/avatar6.png": "7429",
	"./donkey-kong/avatar7.png": "9831",
	"./donkey-kong/full0-min.png": "57c3",
	"./donkey-kong/full1-min.png": "2633",
	"./donkey-kong/full2-min.png": "d9eb",
	"./donkey-kong/full3-min.png": "846b",
	"./donkey-kong/full4-min.png": "be25",
	"./donkey-kong/full5-min.png": "e919",
	"./donkey-kong/full6-min.png": "2c1e",
	"./donkey-kong/full7-min.png": "e571",
	"./donkey-kong/selected0-min.png": "3088",
	"./donkey-kong/selected1-min.png": "1bf7",
	"./donkey-kong/selected2-min.png": "b649",
	"./donkey-kong/selected3-min.png": "e1fa",
	"./donkey-kong/selected4-min.png": "236b",
	"./donkey-kong/selected5-min.png": "cadc",
	"./donkey-kong/selected6-min.png": "0fdd",
	"./donkey-kong/selected7-min.png": "a5e6",
	"./donkey-kong/stock0.png": "c8fc",
	"./donkey-kong/stock1.png": "1998",
	"./donkey-kong/stock2.png": "8a18",
	"./donkey-kong/stock3.png": "8717",
	"./donkey-kong/stock4.png": "866c",
	"./donkey-kong/stock5.png": "a92f",
	"./donkey-kong/stock6.png": "6474",
	"./donkey-kong/stock7.png": "5583",
	"./dr-mario/avatar0.png": "d97e",
	"./dr-mario/avatar1.png": "e9b9",
	"./dr-mario/avatar2.png": "b991",
	"./dr-mario/avatar3.png": "c39e",
	"./dr-mario/avatar4.png": "008c",
	"./dr-mario/avatar5.png": "9a77",
	"./dr-mario/avatar6.png": "4158",
	"./dr-mario/avatar7.png": "6faf",
	"./dr-mario/full0-min.png": "2622",
	"./dr-mario/full1-min.png": "a26c",
	"./dr-mario/full2-min.png": "f7d9",
	"./dr-mario/full3-min.png": "b0de",
	"./dr-mario/full4-min.png": "1885",
	"./dr-mario/full5-min.png": "abca",
	"./dr-mario/full6-min.png": "3071",
	"./dr-mario/full7-min.png": "5753",
	"./dr-mario/selected0-min.png": "3d20",
	"./dr-mario/selected1-min.png": "f66b",
	"./dr-mario/selected2-min.png": "7846",
	"./dr-mario/selected3-min.png": "9fb0",
	"./dr-mario/selected4-min.png": "1695",
	"./dr-mario/selected5-min.png": "76d6",
	"./dr-mario/selected6-min.png": "521f",
	"./dr-mario/selected7-min.png": "77d8",
	"./dr-mario/stock0.png": "d953",
	"./dr-mario/stock1.png": "2a6d",
	"./dr-mario/stock2.png": "546e",
	"./dr-mario/stock3.png": "d63f",
	"./dr-mario/stock4.png": "7395",
	"./dr-mario/stock5.png": "946d",
	"./dr-mario/stock6.png": "9133",
	"./dr-mario/stock7.png": "3d62",
	"./duck-hunt/avatar0.png": "59c5",
	"./duck-hunt/avatar1.png": "c65a",
	"./duck-hunt/avatar2.png": "cc26",
	"./duck-hunt/avatar3.png": "b826",
	"./duck-hunt/avatar4.png": "2ec9",
	"./duck-hunt/avatar5.png": "d3ad",
	"./duck-hunt/avatar6.png": "4737",
	"./duck-hunt/avatar7.png": "62ae",
	"./duck-hunt/full0-min.png": "d4d6",
	"./duck-hunt/full1-min.png": "bcdf",
	"./duck-hunt/full2-min.png": "d0a2",
	"./duck-hunt/full3-min.png": "1a63",
	"./duck-hunt/full4-min.png": "ec60",
	"./duck-hunt/full5-min.png": "0dfb",
	"./duck-hunt/full6-min.png": "bd1c",
	"./duck-hunt/full7-min.png": "000f",
	"./duck-hunt/selected0-min.png": "f313",
	"./duck-hunt/selected1-min.png": "eddc",
	"./duck-hunt/selected2-min.png": "17ed",
	"./duck-hunt/selected3-min.png": "4a78",
	"./duck-hunt/selected4-min.png": "f773",
	"./duck-hunt/selected5-min.png": "7f81",
	"./duck-hunt/selected6-min.png": "45a55",
	"./duck-hunt/selected7-min.png": "23cb6",
	"./duck-hunt/stock0.png": "78303",
	"./duck-hunt/stock1.png": "5f35",
	"./duck-hunt/stock2.png": "eecf",
	"./duck-hunt/stock3.png": "0b04",
	"./duck-hunt/stock4.png": "d990",
	"./duck-hunt/stock5.png": "8aa6",
	"./duck-hunt/stock6.png": "9fcf",
	"./duck-hunt/stock7.png": "fb23",
	"./falco/avatar0.png": "b440",
	"./falco/avatar1.png": "dc0c",
	"./falco/avatar2.png": "8702",
	"./falco/avatar3.png": "949b",
	"./falco/avatar4.png": "81ae",
	"./falco/avatar5.png": "f6a1",
	"./falco/avatar6.png": "47ae",
	"./falco/avatar7.png": "fedd",
	"./falco/full0-min.png": "8437",
	"./falco/full1-min.png": "de09",
	"./falco/full2-min.png": "d3b1",
	"./falco/full3-min.png": "2ebc",
	"./falco/full4-min.png": "1b14",
	"./falco/full5-min.png": "3e44",
	"./falco/full6-min.png": "38b9",
	"./falco/full7-min.png": "c1d6",
	"./falco/selected0-min.png": "0deb",
	"./falco/selected1-min.png": "9c24",
	"./falco/selected2-min.png": "e71f",
	"./falco/selected3-min.png": "0f65",
	"./falco/selected4-min.png": "9c47",
	"./falco/selected5-min.png": "4dce",
	"./falco/selected6-min.png": "cdab",
	"./falco/selected7-min.png": "c162",
	"./falco/stock0.png": "940b",
	"./falco/stock1.png": "1952",
	"./falco/stock2.png": "8723",
	"./falco/stock3.png": "4f4f",
	"./falco/stock4.png": "92a5",
	"./falco/stock5.png": "1a2b",
	"./falco/stock6.png": "2887",
	"./falco/stock7.png": "8eef",
	"./fox/avatar0.png": "218f",
	"./fox/avatar1.png": "ca01",
	"./fox/avatar2.png": "98f5",
	"./fox/avatar3.png": "6ac1",
	"./fox/avatar4.png": "9132",
	"./fox/avatar5.png": "9f5f",
	"./fox/avatar6.png": "b6fc",
	"./fox/avatar7.png": "46fc",
	"./fox/full0-min.png": "1c49",
	"./fox/full1-min.png": "2594",
	"./fox/full2-min.png": "2078",
	"./fox/full3-min.png": "7768",
	"./fox/full4-min.png": "2e9e",
	"./fox/full5-min.png": "cf4d",
	"./fox/full6-min.png": "9e80",
	"./fox/full7-min.png": "3a82",
	"./fox/selected0-min.png": "4c61",
	"./fox/selected1-min.png": "eef8",
	"./fox/selected2-min.png": "4685",
	"./fox/selected3-min.png": "44ed",
	"./fox/selected4-min.png": "bf43",
	"./fox/selected5-min.png": "5ba4",
	"./fox/selected6-min.png": "8cdc",
	"./fox/selected7-min.png": "91b6",
	"./fox/stock0.png": "c930",
	"./fox/stock1.png": "200a8",
	"./fox/stock2.png": "985b",
	"./fox/stock3.png": "95b2",
	"./fox/stock4.png": "9428",
	"./fox/stock5.png": "b8fd",
	"./fox/stock6.png": "1ca6",
	"./fox/stock7.png": "96cc",
	"./ganondorf/avatar0.png": "77892",
	"./ganondorf/avatar1.png": "74ec",
	"./ganondorf/avatar2.png": "bc41",
	"./ganondorf/avatar3.png": "1b43",
	"./ganondorf/avatar4.png": "2f85",
	"./ganondorf/avatar5.png": "9e40",
	"./ganondorf/avatar6.png": "85a5",
	"./ganondorf/avatar7.png": "5a09",
	"./ganondorf/full0-min.png": "e742",
	"./ganondorf/full1-min.png": "f88f",
	"./ganondorf/full2-min.png": "858b",
	"./ganondorf/full3-min.png": "f8c0",
	"./ganondorf/full4-min.png": "6167",
	"./ganondorf/full5-min.png": "062b",
	"./ganondorf/full6-min.png": "e90f",
	"./ganondorf/full7-min.png": "3cd9",
	"./ganondorf/selected0-min.png": "6dce",
	"./ganondorf/selected1-min.png": "d988",
	"./ganondorf/selected2-min.png": "32f1",
	"./ganondorf/selected3-min.png": "1e34",
	"./ganondorf/selected4-min.png": "692f",
	"./ganondorf/selected5-min.png": "8f94",
	"./ganondorf/selected6-min.png": "9e90",
	"./ganondorf/selected7-min.png": "0e22",
	"./ganondorf/stock0.png": "da45",
	"./ganondorf/stock1.png": "b0d6",
	"./ganondorf/stock2.png": "9103",
	"./ganondorf/stock3.png": "bc50",
	"./ganondorf/stock4.png": "1d24",
	"./ganondorf/stock5.png": "3185",
	"./ganondorf/stock6.png": "0e75",
	"./ganondorf/stock7.png": "ea98",
	"./greninja/avatar0.png": "4e32",
	"./greninja/avatar1.png": "5d8b",
	"./greninja/avatar2.png": "b929",
	"./greninja/avatar3.png": "a30f",
	"./greninja/avatar4.png": "8282",
	"./greninja/avatar5.png": "1296",
	"./greninja/avatar6.png": "97c0",
	"./greninja/avatar7.png": "07df",
	"./greninja/full0-min.png": "626c",
	"./greninja/full1-min.png": "f245",
	"./greninja/full2-min.png": "80c7",
	"./greninja/full3-min.png": "6ac0",
	"./greninja/full4-min.png": "8281",
	"./greninja/full5-min.png": "3f66",
	"./greninja/full6-min.png": "46aa",
	"./greninja/full7-min.png": "794b",
	"./greninja/selected0-min.png": "f034",
	"./greninja/selected1-min.png": "dc9c",
	"./greninja/selected2-min.png": "a166",
	"./greninja/selected3-min.png": "6746",
	"./greninja/selected4-min.png": "07ae",
	"./greninja/selected5-min.png": "918f",
	"./greninja/selected6-min.png": "0258",
	"./greninja/selected7-min.png": "49b4",
	"./greninja/stock0.png": "695c",
	"./greninja/stock1.png": "46eb",
	"./greninja/stock2.png": "6fb6",
	"./greninja/stock3.png": "7d03",
	"./greninja/stock4.png": "7913",
	"./greninja/stock5.png": "aa31",
	"./greninja/stock6.png": "8439",
	"./greninja/stock7.png": "0700",
	"./hero/avatar0.png": "90ff",
	"./hero/avatar1.png": "fce4",
	"./hero/avatar2.png": "0158",
	"./hero/avatar3.png": "0e0b",
	"./hero/avatar4.png": "4c03",
	"./hero/avatar5.png": "20c9",
	"./hero/avatar6.png": "cc99",
	"./hero/avatar7.png": "695f",
	"./hero/full0-min.png": "75be",
	"./hero/full1-min.png": "ca83",
	"./hero/full2-min.png": "480b",
	"./hero/full3-min.png": "7ec2",
	"./hero/full4-min.png": "abd6",
	"./hero/full5-min.png": "706c",
	"./hero/full6-min.png": "ee59",
	"./hero/full7-min.png": "270e",
	"./hero/selected0-min.png": "ad33",
	"./hero/selected1-min.png": "ff48",
	"./hero/selected2-min.png": "d721",
	"./hero/selected3-min.png": "2903",
	"./hero/selected4-min.png": "656a",
	"./hero/selected5-min.png": "f4da",
	"./hero/selected6-min.png": "a6309",
	"./hero/selected7-min.png": "5818",
	"./hero/stock0.png": "d221",
	"./hero/stock1.png": "d70a",
	"./hero/stock2.png": "7384",
	"./hero/stock3.png": "e459",
	"./hero/stock4.png": "e7ae",
	"./hero/stock5.png": "f178",
	"./hero/stock6.png": "dc23",
	"./hero/stock7.png": "57dd",
	"./ice-climbers/avatar0.png": "3f95",
	"./ice-climbers/avatar1.png": "948b",
	"./ice-climbers/avatar2.png": "f137",
	"./ice-climbers/avatar3.png": "2b1c",
	"./ice-climbers/avatar4.png": "e9dc",
	"./ice-climbers/avatar5.png": "8192",
	"./ice-climbers/avatar6.png": "3188",
	"./ice-climbers/avatar7.png": "60c1",
	"./ice-climbers/full0-min.png": "8e52",
	"./ice-climbers/full1-min.png": "f848",
	"./ice-climbers/full2-min.png": "1cc6",
	"./ice-climbers/full3-min.png": "c914",
	"./ice-climbers/full4-min.png": "4484",
	"./ice-climbers/full5-min.png": "a85a",
	"./ice-climbers/full6-min.png": "266a",
	"./ice-climbers/full7-min.png": "5979",
	"./ice-climbers/selected0-min.png": "74e5",
	"./ice-climbers/selected1-min.png": "5009",
	"./ice-climbers/selected2-min.png": "2052",
	"./ice-climbers/selected3-min.png": "b2d6",
	"./ice-climbers/selected4-min.png": "8b1c",
	"./ice-climbers/selected5-min.png": "087e",
	"./ice-climbers/selected6-min.png": "0349",
	"./ice-climbers/selected7-min.png": "04ce",
	"./ice-climbers/stock0.png": "ccf1",
	"./ice-climbers/stock1.png": "57a1",
	"./ice-climbers/stock2.png": "1514",
	"./ice-climbers/stock3.png": "58a84",
	"./ice-climbers/stock4.png": "12e8",
	"./ice-climbers/stock5.png": "5b57",
	"./ice-climbers/stock6.png": "793b",
	"./ice-climbers/stock7.png": "ead1",
	"./ike/avatar0.png": "d3d9",
	"./ike/avatar1.png": "297e",
	"./ike/avatar2.png": "26353",
	"./ike/avatar3.png": "0b2c",
	"./ike/avatar4.png": "3a4d",
	"./ike/avatar5.png": "2ddf",
	"./ike/avatar6.png": "57c9",
	"./ike/avatar7.png": "4be2",
	"./ike/full0-min.png": "c76c",
	"./ike/full1-min.png": "a824",
	"./ike/full2-min.png": "7a50",
	"./ike/full3-min.png": "a719",
	"./ike/full4-min.png": "7c4f",
	"./ike/full5-min.png": "11ff",
	"./ike/full6-min.png": "8bbf",
	"./ike/full7-min.png": "ee84",
	"./ike/selected0-min.png": "9bdde",
	"./ike/selected1-min.png": "b62c",
	"./ike/selected2-min.png": "8292",
	"./ike/selected3-min.png": "fdc4",
	"./ike/selected4-min.png": "0daf",
	"./ike/selected5-min.png": "acec",
	"./ike/selected6-min.png": "1008",
	"./ike/selected7-min.png": "66fc",
	"./ike/stock0.png": "807c",
	"./ike/stock1.png": "88fd",
	"./ike/stock2.png": "f3dc",
	"./ike/stock3.png": "01f5",
	"./ike/stock4.png": "ad5c",
	"./ike/stock5.png": "6706",
	"./ike/stock6.png": "3ace",
	"./ike/stock7.png": "0cad",
	"./incineroar/avatar0.png": "2c8c",
	"./incineroar/avatar1.png": "56d9",
	"./incineroar/avatar2.png": "c514",
	"./incineroar/avatar3.png": "8182",
	"./incineroar/avatar4.png": "eb55",
	"./incineroar/avatar5.png": "fcf6",
	"./incineroar/avatar6.png": "b354",
	"./incineroar/avatar7.png": "a173",
	"./incineroar/full0-min.png": "74d3",
	"./incineroar/full1-min.png": "16f9",
	"./incineroar/full2-min.png": "31c6",
	"./incineroar/full3-min.png": "3170",
	"./incineroar/full4-min.png": "91e0",
	"./incineroar/full5-min.png": "c2f6",
	"./incineroar/full6-min.png": "da7f",
	"./incineroar/full7-min.png": "ec8c",
	"./incineroar/selected0-min.png": "9eae",
	"./incineroar/selected1-min.png": "db04",
	"./incineroar/selected2-min.png": "029b",
	"./incineroar/selected3-min.png": "1e18",
	"./incineroar/selected4-min.png": "7918e",
	"./incineroar/selected5-min.png": "1fa6",
	"./incineroar/selected6-min.png": "2a0c",
	"./incineroar/selected7-min.png": "5262",
	"./incineroar/stock0.png": "59e7",
	"./incineroar/stock1.png": "bae0",
	"./incineroar/stock2.png": "2303c",
	"./incineroar/stock3.png": "5ecf",
	"./incineroar/stock4.png": "98d0",
	"./incineroar/stock5.png": "bed2",
	"./incineroar/stock6.png": "2d7f",
	"./incineroar/stock7.png": "3627",
	"./inkling/avatar0.png": "4b63",
	"./inkling/avatar1.png": "4cdb",
	"./inkling/avatar2.png": "b2f5",
	"./inkling/avatar3.png": "a5b2",
	"./inkling/avatar4.png": "c0dc",
	"./inkling/avatar5.png": "07ef",
	"./inkling/avatar6.png": "aee1",
	"./inkling/avatar7.png": "8309",
	"./inkling/full0-min.png": "e72c",
	"./inkling/full1-min.png": "0ef8",
	"./inkling/full2-min.png": "ca6e",
	"./inkling/full3-min.png": "5e47",
	"./inkling/full4-min.png": "4f4b",
	"./inkling/full5-min.png": "216f",
	"./inkling/full6-min.png": "748e",
	"./inkling/full7-min.png": "110e",
	"./inkling/selected0-min.png": "ae83",
	"./inkling/selected1-min.png": "bd0d",
	"./inkling/selected2-min.png": "0e8a",
	"./inkling/selected3-min.png": "a425",
	"./inkling/selected4-min.png": "e3c4",
	"./inkling/selected5-min.png": "3682",
	"./inkling/selected6-min.png": "a1ab",
	"./inkling/selected7-min.png": "4121",
	"./inkling/stock0.png": "0ec9",
	"./inkling/stock1.png": "db98",
	"./inkling/stock2.png": "5d06",
	"./inkling/stock3.png": "87d9",
	"./inkling/stock4.png": "c439",
	"./inkling/stock5.png": "24d6",
	"./inkling/stock6.png": "0f76",
	"./inkling/stock7.png": "bd85",
	"./isabelle/avatar0.png": "7b390",
	"./isabelle/avatar1.png": "6f13",
	"./isabelle/avatar2.png": "ebc7",
	"./isabelle/avatar3.png": "0146",
	"./isabelle/avatar4.png": "8227",
	"./isabelle/avatar5.png": "0d79",
	"./isabelle/avatar6.png": "b6c0",
	"./isabelle/avatar7.png": "e371",
	"./isabelle/full0-min.png": "6020",
	"./isabelle/full1-min.png": "b842",
	"./isabelle/full2-min.png": "55a7",
	"./isabelle/full3-min.png": "79c2",
	"./isabelle/full4-min.png": "6723",
	"./isabelle/full5-min.png": "c639",
	"./isabelle/full6-min.png": "5c2b",
	"./isabelle/full7-min.png": "3f49",
	"./isabelle/selected0-min.png": "80c3",
	"./isabelle/selected1-min.png": "1c50",
	"./isabelle/selected2-min.png": "c9f3",
	"./isabelle/selected3-min.png": "c64e",
	"./isabelle/selected4-min.png": "46b8",
	"./isabelle/selected5-min.png": "8708",
	"./isabelle/selected6-min.png": "dc51",
	"./isabelle/selected7-min.png": "fcac",
	"./isabelle/stock0.png": "cf5f",
	"./isabelle/stock1.png": "d465",
	"./isabelle/stock2.png": "06fa",
	"./isabelle/stock3.png": "f4c1",
	"./isabelle/stock4.png": "87a7",
	"./isabelle/stock5.png": "0722",
	"./isabelle/stock6.png": "9e76",
	"./isabelle/stock7.png": "8ff6",
	"./jigglypuff/avatar0.png": "5e91",
	"./jigglypuff/avatar1.png": "5157",
	"./jigglypuff/avatar2.png": "2d16",
	"./jigglypuff/avatar3.png": "c536",
	"./jigglypuff/avatar4.png": "9ee6",
	"./jigglypuff/avatar5.png": "f71e",
	"./jigglypuff/avatar6.png": "4ede",
	"./jigglypuff/avatar7.png": "1e8e",
	"./jigglypuff/full0-min.png": "1c56",
	"./jigglypuff/full1-min.png": "0600",
	"./jigglypuff/full2-min.png": "d23e",
	"./jigglypuff/full3-min.png": "870c",
	"./jigglypuff/full4-min.png": "1bd0",
	"./jigglypuff/full5-min.png": "f846",
	"./jigglypuff/full6-min.png": "b83c",
	"./jigglypuff/full7-min.png": "22a0",
	"./jigglypuff/selected0-min.png": "e5e5",
	"./jigglypuff/selected1-min.png": "6c80",
	"./jigglypuff/selected2-min.png": "50bd",
	"./jigglypuff/selected3-min.png": "6d67",
	"./jigglypuff/selected4-min.png": "c6a0",
	"./jigglypuff/selected5-min.png": "9c5f",
	"./jigglypuff/selected6-min.png": "d988c",
	"./jigglypuff/selected7-min.png": "4183",
	"./jigglypuff/stock0.png": "c98d",
	"./jigglypuff/stock1.png": "6645",
	"./jigglypuff/stock2.png": "1980",
	"./jigglypuff/stock3.png": "1dcc",
	"./jigglypuff/stock4.png": "fad6",
	"./jigglypuff/stock5.png": "e112",
	"./jigglypuff/stock6.png": "87b1",
	"./jigglypuff/stock7.png": "5380",
	"./joker/avatar0.png": "2879",
	"./joker/avatar1.png": "e9ec",
	"./joker/avatar2.png": "3983",
	"./joker/avatar3.png": "c8b0",
	"./joker/avatar4.png": "47cb",
	"./joker/avatar5.png": "bddf",
	"./joker/avatar6.png": "4218",
	"./joker/avatar7.png": "72b6",
	"./joker/full0-min.png": "c54a",
	"./joker/full1-min.png": "c5ce",
	"./joker/full2-min.png": "82f9",
	"./joker/full3-min.png": "2192",
	"./joker/full4-min.png": "af4f",
	"./joker/full5-min.png": "a8b7",
	"./joker/full6-min.png": "c7fc",
	"./joker/full7-min.png": "032d",
	"./joker/selected0-min.png": "1558",
	"./joker/selected1-min.png": "baff",
	"./joker/selected2-min.png": "ea9b",
	"./joker/selected3-min.png": "ff59",
	"./joker/selected4-min.png": "6e25",
	"./joker/selected5-min.png": "c2d4",
	"./joker/selected6-min.png": "d6ad",
	"./joker/selected7-min.png": "82fb",
	"./joker/stock0.png": "6e4a",
	"./joker/stock1.png": "ccc8",
	"./joker/stock2.png": "e82b",
	"./joker/stock3.png": "b5f6",
	"./joker/stock4.png": "888f",
	"./joker/stock5.png": "0b382",
	"./joker/stock6.png": "2c02",
	"./joker/stock7.png": "1b61",
	"./kazuya/avatar0.png": "7285",
	"./kazuya/avatar1.png": "0aa5",
	"./kazuya/avatar2.png": "f15b",
	"./kazuya/avatar3.png": "57b0",
	"./kazuya/avatar4.png": "fdd2",
	"./kazuya/avatar5.png": "0a87",
	"./kazuya/avatar6.png": "3269",
	"./kazuya/avatar7.png": "eae3",
	"./kazuya/full0-min.png": "2590",
	"./kazuya/full1-min.png": "6f7f",
	"./kazuya/full2-min.png": "db34",
	"./kazuya/full3-min.png": "f192",
	"./kazuya/full4-min.png": "6b25",
	"./kazuya/full5-min.png": "5db4",
	"./kazuya/full6-min.png": "695d",
	"./kazuya/full7-min.png": "cd17",
	"./kazuya/selected0-min.png": "f4c3",
	"./kazuya/selected1-min.png": "1052",
	"./kazuya/selected2-min.png": "6961",
	"./kazuya/selected3-min.png": "b278",
	"./kazuya/selected4-min.png": "9048",
	"./kazuya/selected5-min.png": "18e9",
	"./kazuya/selected6-min.png": "3c76",
	"./kazuya/selected7-min.png": "910b",
	"./kazuya/stock0.png": "bdc7",
	"./kazuya/stock1.png": "92e8",
	"./kazuya/stock2.png": "d6d0",
	"./kazuya/stock3.png": "7d8f",
	"./kazuya/stock4.png": "62ba",
	"./kazuya/stock5.png": "9605",
	"./kazuya/stock6.png": "ccee",
	"./kazuya/stock7.png": "6cd4",
	"./ken/avatar0.png": "01f9",
	"./ken/avatar1.png": "9266",
	"./ken/avatar2.png": "256e",
	"./ken/avatar3.png": "7fca",
	"./ken/avatar4.png": "815c",
	"./ken/avatar5.png": "5977",
	"./ken/avatar6.png": "46fd",
	"./ken/avatar7.png": "77d0",
	"./ken/full0-min.png": "d245",
	"./ken/full1-min.png": "93ab",
	"./ken/full2-min.png": "b3dc",
	"./ken/full3-min.png": "512b",
	"./ken/full4-min.png": "f5de",
	"./ken/full5-min.png": "6fa5",
	"./ken/full6-min.png": "6350",
	"./ken/full7-min.png": "c4f7",
	"./ken/selected0-min.png": "537e",
	"./ken/selected1-min.png": "17b0",
	"./ken/selected2-min.png": "7830",
	"./ken/selected3-min.png": "5cbf",
	"./ken/selected4-min.png": "00a9",
	"./ken/selected5-min.png": "680d",
	"./ken/selected6-min.png": "2460",
	"./ken/selected7-min.png": "1c4b",
	"./ken/stock0.png": "98c4",
	"./ken/stock1.png": "055d",
	"./ken/stock2.png": "8993",
	"./ken/stock3.png": "d3e2",
	"./ken/stock4.png": "cce0",
	"./ken/stock5.png": "1889",
	"./ken/stock6.png": "4b66",
	"./ken/stock7.png": "f9e5",
	"./king-dedede/avatar0.png": "1632",
	"./king-dedede/avatar1.png": "5581",
	"./king-dedede/avatar2.png": "f764",
	"./king-dedede/avatar3.png": "d2a2",
	"./king-dedede/avatar4.png": "21a4",
	"./king-dedede/avatar5.png": "9e66",
	"./king-dedede/avatar6.png": "267c",
	"./king-dedede/avatar7.png": "ec9d",
	"./king-dedede/full0-min.png": "e4d8",
	"./king-dedede/full1-min.png": "be72",
	"./king-dedede/full2-min.png": "a372",
	"./king-dedede/full3-min.png": "4d1ad",
	"./king-dedede/full4-min.png": "f585",
	"./king-dedede/full5-min.png": "98cb",
	"./king-dedede/full6-min.png": "3f9e",
	"./king-dedede/full7-min.png": "af39",
	"./king-dedede/selected0-min.png": "0ea2",
	"./king-dedede/selected1-min.png": "ec49",
	"./king-dedede/selected2-min.png": "5af4",
	"./king-dedede/selected3-min.png": "2d96",
	"./king-dedede/selected4-min.png": "c8d9",
	"./king-dedede/selected5-min.png": "6d2e",
	"./king-dedede/selected6-min.png": "5751",
	"./king-dedede/selected7-min.png": "fb9a",
	"./king-dedede/stock0.png": "61f8",
	"./king-dedede/stock1.png": "233a",
	"./king-dedede/stock2.png": "adf5",
	"./king-dedede/stock3.png": "d8ea",
	"./king-dedede/stock4.png": "4ce8",
	"./king-dedede/stock5.png": "ec9a",
	"./king-dedede/stock6.png": "4a2f",
	"./king-dedede/stock7.png": "ad09",
	"./king-k-rool/avatar0.png": "259a",
	"./king-k-rool/avatar1.png": "3b2c",
	"./king-k-rool/avatar2.png": "7da8",
	"./king-k-rool/avatar3.png": "03d8",
	"./king-k-rool/avatar4.png": "aba2",
	"./king-k-rool/avatar5.png": "b5c1",
	"./king-k-rool/avatar6.png": "fee5",
	"./king-k-rool/avatar7.png": "2e22",
	"./king-k-rool/full0-min.png": "04c0",
	"./king-k-rool/full1-min.png": "c571",
	"./king-k-rool/full2-min.png": "79d3",
	"./king-k-rool/full3-min.png": "1c50a",
	"./king-k-rool/full4-min.png": "ced6",
	"./king-k-rool/full5-min.png": "b2e9",
	"./king-k-rool/full6-min.png": "fe9b",
	"./king-k-rool/full7-min.png": "f7ca",
	"./king-k-rool/selected0-min.png": "6917",
	"./king-k-rool/selected1-min.png": "2b2d",
	"./king-k-rool/selected2-min.png": "20dd",
	"./king-k-rool/selected3-min.png": "2a37",
	"./king-k-rool/selected4-min.png": "a440",
	"./king-k-rool/selected5-min.png": "6f1b",
	"./king-k-rool/selected6-min.png": "e90d",
	"./king-k-rool/selected7-min.png": "7c64",
	"./king-k-rool/stock0.png": "8c01",
	"./king-k-rool/stock1.png": "b8a7",
	"./king-k-rool/stock2.png": "d5f1",
	"./king-k-rool/stock3.png": "aeae",
	"./king-k-rool/stock4.png": "0805",
	"./king-k-rool/stock5.png": "b0ec",
	"./king-k-rool/stock6.png": "d77f",
	"./king-k-rool/stock7.png": "c08f",
	"./kirby/avatar0.png": "4565",
	"./kirby/avatar1.png": "c150",
	"./kirby/avatar2.png": "e144",
	"./kirby/avatar3.png": "eba0",
	"./kirby/avatar4.png": "66d17",
	"./kirby/avatar5.png": "8a13",
	"./kirby/avatar6.png": "d135",
	"./kirby/avatar7.png": "178d",
	"./kirby/full0-min.png": "eca4",
	"./kirby/full1-min.png": "522a",
	"./kirby/full2-min.png": "944f",
	"./kirby/full3-min.png": "47f1",
	"./kirby/full4-min.png": "76e1",
	"./kirby/full5-min.png": "6ac3",
	"./kirby/full6-min.png": "53d3",
	"./kirby/full7-min.png": "3530",
	"./kirby/selected0-min.png": "00a6",
	"./kirby/selected1-min.png": "8ffe",
	"./kirby/selected2-min.png": "ccec",
	"./kirby/selected3-min.png": "bf90",
	"./kirby/selected4-min.png": "3bd5",
	"./kirby/selected5-min.png": "c4e7",
	"./kirby/selected6-min.png": "9026",
	"./kirby/selected7-min.png": "f5d4",
	"./kirby/stock0.png": "b251",
	"./kirby/stock1.png": "189d",
	"./kirby/stock2.png": "d907",
	"./kirby/stock3.png": "832d",
	"./kirby/stock4.png": "9d15",
	"./kirby/stock5.png": "9c9e",
	"./kirby/stock6.png": "cc53",
	"./kirby/stock7.png": "d223",
	"./link/avatar0.png": "30a9",
	"./link/avatar1.png": "43ad",
	"./link/avatar2.png": "a6a0",
	"./link/avatar3.png": "6df7",
	"./link/avatar4.png": "fe93",
	"./link/avatar5.png": "0bbf",
	"./link/avatar6.png": "947a",
	"./link/avatar7.png": "4d9d",
	"./link/full0-min.png": "04ee",
	"./link/full1-min.png": "f421",
	"./link/full2-min.png": "419a",
	"./link/full3-min.png": "450a",
	"./link/full4-min.png": "5cbf3",
	"./link/full5-min.png": "d7ad",
	"./link/full6-min.png": "a4fd",
	"./link/full7-min.png": "4198",
	"./link/selected0-min.png": "6ce9",
	"./link/selected1-min.png": "3464",
	"./link/selected2-min.png": "fa74",
	"./link/selected3-min.png": "a1b4",
	"./link/selected4-min.png": "e8a9",
	"./link/selected5-min.png": "440b",
	"./link/selected6-min.png": "5baa",
	"./link/selected7-min.png": "71c3",
	"./link/stock0.png": "540b",
	"./link/stock1.png": "8ec3",
	"./link/stock2.png": "433a",
	"./link/stock3.png": "ca63",
	"./link/stock4.png": "4192",
	"./link/stock5.png": "cb80",
	"./link/stock6.png": "49af",
	"./link/stock7.png": "7e96",
	"./little-mac/avatar0.png": "a222",
	"./little-mac/avatar1.png": "2f3a9",
	"./little-mac/avatar2.png": "9c43",
	"./little-mac/avatar3.png": "8151",
	"./little-mac/avatar4.png": "5286",
	"./little-mac/avatar5.png": "e67b",
	"./little-mac/avatar6.png": "882b",
	"./little-mac/avatar7.png": "9c5f0",
	"./little-mac/full0-min.png": "3355",
	"./little-mac/full1-min.png": "a935",
	"./little-mac/full2-min.png": "dea4",
	"./little-mac/full3-min.png": "bd62",
	"./little-mac/full4-min.png": "6f52",
	"./little-mac/full5-min.png": "584e",
	"./little-mac/full6-min.png": "e964",
	"./little-mac/full7-min.png": "6a97",
	"./little-mac/selected0-min.png": "6e3a",
	"./little-mac/selected1-min.png": "9ee0a",
	"./little-mac/selected2-min.png": "3c17",
	"./little-mac/selected3-min.png": "61db",
	"./little-mac/selected4-min.png": "a1b41",
	"./little-mac/selected5-min.png": "75e8",
	"./little-mac/selected6-min.png": "f41f",
	"./little-mac/selected7-min.png": "3e8b",
	"./little-mac/stock0.png": "f27e",
	"./little-mac/stock1.png": "c2a8",
	"./little-mac/stock2.png": "1e7f",
	"./little-mac/stock3.png": "426b",
	"./little-mac/stock4.png": "de62",
	"./little-mac/stock5.png": "2f8d",
	"./little-mac/stock6.png": "e12e",
	"./little-mac/stock7.png": "62e5",
	"./lucario/avatar0.png": "1f11",
	"./lucario/avatar1.png": "d44e9",
	"./lucario/avatar2.png": "7678",
	"./lucario/avatar3.png": "4b45",
	"./lucario/avatar4.png": "f0c2",
	"./lucario/avatar5.png": "b809",
	"./lucario/avatar6.png": "8928",
	"./lucario/avatar7.png": "4841",
	"./lucario/full0-min.png": "74ad",
	"./lucario/full1-min.png": "3540",
	"./lucario/full2-min.png": "f7ab",
	"./lucario/full3-min.png": "1ca1",
	"./lucario/full4-min.png": "ac34",
	"./lucario/full5-min.png": "96ab",
	"./lucario/full6-min.png": "c6ca",
	"./lucario/full7-min.png": "3e08",
	"./lucario/selected0-min.png": "2a10",
	"./lucario/selected1-min.png": "d21a",
	"./lucario/selected2-min.png": "f0e4",
	"./lucario/selected3-min.png": "6c06",
	"./lucario/selected4-min.png": "bf04",
	"./lucario/selected5-min.png": "f560",
	"./lucario/selected6-min.png": "469c",
	"./lucario/selected7-min.png": "9b73",
	"./lucario/stock0.png": "d149",
	"./lucario/stock1.png": "0a0c",
	"./lucario/stock2.png": "e299",
	"./lucario/stock3.png": "3e40",
	"./lucario/stock4.png": "26d4",
	"./lucario/stock5.png": "5b4b",
	"./lucario/stock6.png": "50f9",
	"./lucario/stock7.png": "9994",
	"./lucas/avatar0.png": "fa0e",
	"./lucas/avatar1.png": "5129",
	"./lucas/avatar2.png": "3732",
	"./lucas/avatar3.png": "37ab",
	"./lucas/avatar4.png": "fd34",
	"./lucas/avatar5.png": "1645",
	"./lucas/avatar6.png": "44ba",
	"./lucas/avatar7.png": "627e",
	"./lucas/full0-min.png": "7c28",
	"./lucas/full1-min.png": "23fb",
	"./lucas/full2-min.png": "4123",
	"./lucas/full3-min.png": "d42f",
	"./lucas/full4-min.png": "26fd",
	"./lucas/full5-min.png": "f455",
	"./lucas/full6-min.png": "e6a5",
	"./lucas/full7-min.png": "dfb1",
	"./lucas/selected0-min.png": "2f75",
	"./lucas/selected1-min.png": "6223",
	"./lucas/selected2-min.png": "6c84",
	"./lucas/selected3-min.png": "3595",
	"./lucas/selected4-min.png": "8c74",
	"./lucas/selected5-min.png": "e486",
	"./lucas/selected6-min.png": "631e",
	"./lucas/selected7-min.png": "43b4",
	"./lucas/stock0.png": "95c5",
	"./lucas/stock1.png": "003d",
	"./lucas/stock2.png": "b902",
	"./lucas/stock3.png": "1b9c",
	"./lucas/stock4.png": "8451",
	"./lucas/stock5.png": "fce7",
	"./lucas/stock6.png": "d6ce",
	"./lucas/stock7.png": "65f3",
	"./lucina/avatar0.png": "bc87",
	"./lucina/avatar1.png": "0816",
	"./lucina/avatar2.png": "4dc1",
	"./lucina/avatar3.png": "8b8cf",
	"./lucina/avatar4.png": "006f",
	"./lucina/avatar5.png": "7c13",
	"./lucina/avatar6.png": "ba7f",
	"./lucina/avatar7.png": "0141",
	"./lucina/full0-min.png": "17b8",
	"./lucina/full1-min.png": "be32",
	"./lucina/full2-min.png": "2f3a",
	"./lucina/full3-min.png": "d6bb",
	"./lucina/full4-min.png": "b429",
	"./lucina/full5-min.png": "a147",
	"./lucina/full6-min.png": "d2f3",
	"./lucina/full7-min.png": "d0a1",
	"./lucina/selected0-min.png": "874a",
	"./lucina/selected1-min.png": "f568",
	"./lucina/selected2-min.png": "e9df",
	"./lucina/selected3-min.png": "2769",
	"./lucina/selected4-min.png": "333d",
	"./lucina/selected5-min.png": "cc89",
	"./lucina/selected6-min.png": "ac00",
	"./lucina/selected7-min.png": "5584",
	"./lucina/stock0.png": "8b35",
	"./lucina/stock1.png": "4cd6",
	"./lucina/stock2.png": "a4ac",
	"./lucina/stock3.png": "a2e9",
	"./lucina/stock4.png": "c9a7",
	"./lucina/stock5.png": "9756",
	"./lucina/stock6.png": "03c8",
	"./lucina/stock7.png": "5871",
	"./luigi/avatar0.png": "716b",
	"./luigi/avatar1.png": "b8fe",
	"./luigi/avatar2.png": "0e5f",
	"./luigi/avatar3.png": "ea0b",
	"./luigi/avatar4.png": "c903",
	"./luigi/avatar5.png": "5808",
	"./luigi/avatar6.png": "6abc",
	"./luigi/avatar7.png": "f06a",
	"./luigi/full0-min.png": "4699",
	"./luigi/full1-min.png": "4a3e",
	"./luigi/full2-min.png": "fb36",
	"./luigi/full3-min.png": "ee7b",
	"./luigi/full4-min.png": "c9ea",
	"./luigi/full5-min.png": "2131",
	"./luigi/full6-min.png": "bee1",
	"./luigi/full7-min.png": "0b6a",
	"./luigi/selected0-min.png": "9351",
	"./luigi/selected1-min.png": "08b0",
	"./luigi/selected2-min.png": "c234",
	"./luigi/selected3-min.png": "165c",
	"./luigi/selected4-min.png": "bc17",
	"./luigi/selected5-min.png": "e155",
	"./luigi/selected6-min.png": "b15b",
	"./luigi/selected7-min.png": "9d2e",
	"./luigi/stock0.png": "3605",
	"./luigi/stock1.png": "73f0",
	"./luigi/stock2.png": "8439d",
	"./luigi/stock3.png": "7163",
	"./luigi/stock4.png": "11df",
	"./luigi/stock5.png": "a1c6",
	"./luigi/stock6.png": "37fd",
	"./luigi/stock7.png": "dce2",
	"./mario/avatar0.png": "3c648",
	"./mario/avatar1.png": "98d7",
	"./mario/avatar2.png": "3bbd",
	"./mario/avatar3.png": "0683",
	"./mario/avatar4.png": "9fe3",
	"./mario/avatar5.png": "b6d5",
	"./mario/avatar6.png": "1a6f",
	"./mario/avatar7.png": "06e8",
	"./mario/full0-min.png": "cde6",
	"./mario/full1-min.png": "81ef",
	"./mario/full2-min.png": "9feb",
	"./mario/full3-min.png": "3368",
	"./mario/full4-min.png": "adf9",
	"./mario/full5-min.png": "3323",
	"./mario/full6-min.png": "ba05",
	"./mario/full7-min.png": "4431",
	"./mario/selected0-min.png": "4fd5",
	"./mario/selected1-min.png": "76db",
	"./mario/selected2-min.png": "af07",
	"./mario/selected3-min.png": "95a7",
	"./mario/selected4-min.png": "6091",
	"./mario/selected5-min.png": "106e",
	"./mario/selected6-min.png": "7a36",
	"./mario/selected7-min.png": "c367",
	"./mario/stock0.png": "d93f",
	"./mario/stock1.png": "b00b",
	"./mario/stock2.png": "36b7",
	"./mario/stock3.png": "3dfe",
	"./mario/stock4.png": "8992",
	"./mario/stock5.png": "4e47",
	"./mario/stock6.png": "8bee",
	"./mario/stock7.png": "2ece",
	"./marth/avatar0.png": "32d6",
	"./marth/avatar1.png": "ef98",
	"./marth/avatar2.png": "1768",
	"./marth/avatar3.png": "57c7",
	"./marth/avatar4.png": "9f5b",
	"./marth/avatar5.png": "69b7",
	"./marth/avatar6.png": "1ef8",
	"./marth/avatar7.png": "46fb",
	"./marth/full0-min.png": "db17",
	"./marth/full1-min.png": "84b3",
	"./marth/full2-min.png": "4092",
	"./marth/full3-min.png": "0033",
	"./marth/full4-min.png": "69bd",
	"./marth/full5-min.png": "67a2",
	"./marth/full6-min.png": "4771",
	"./marth/full7-min.png": "8ce4",
	"./marth/selected0-min.png": "d4c8",
	"./marth/selected1-min.png": "c05e",
	"./marth/selected2-min.png": "32b1",
	"./marth/selected3-min.png": "d05b",
	"./marth/selected4-min.png": "b43e",
	"./marth/selected5-min.png": "a599",
	"./marth/selected6-min.png": "d935",
	"./marth/selected7-min.png": "062e",
	"./marth/stock0.png": "662a",
	"./marth/stock1.png": "f080",
	"./marth/stock2.png": "acdb",
	"./marth/stock3.png": "6717",
	"./marth/stock4.png": "e324",
	"./marth/stock5.png": "4e69",
	"./marth/stock6.png": "f7de",
	"./marth/stock7.png": "790a",
	"./mega-man/avatar0.png": "a6e2",
	"./mega-man/avatar1.png": "88a6",
	"./mega-man/avatar2.png": "e670",
	"./mega-man/avatar3.png": "1227",
	"./mega-man/avatar4.png": "b094",
	"./mega-man/avatar5.png": "5339",
	"./mega-man/avatar6.png": "5f3e",
	"./mega-man/avatar7.png": "9937",
	"./mega-man/full0-min.png": "f11f",
	"./mega-man/full1-min.png": "0e35",
	"./mega-man/full2-min.png": "a486",
	"./mega-man/full3-min.png": "1bbe",
	"./mega-man/full4-min.png": "5eea",
	"./mega-man/full5-min.png": "6c94",
	"./mega-man/full6-min.png": "55de",
	"./mega-man/full7-min.png": "af1a",
	"./mega-man/selected0-min.png": "ff7b",
	"./mega-man/selected1-min.png": "1697",
	"./mega-man/selected2-min.png": "043a",
	"./mega-man/selected3-min.png": "8ba7",
	"./mega-man/selected4-min.png": "c561",
	"./mega-man/selected5-min.png": "c350",
	"./mega-man/selected6-min.png": "87f2",
	"./mega-man/selected7-min.png": "3ac3",
	"./mega-man/stock0.png": "f5c8",
	"./mega-man/stock1.png": "f50a",
	"./mega-man/stock2.png": "76e4",
	"./mega-man/stock3.png": "a591",
	"./mega-man/stock4.png": "6d4e",
	"./mega-man/stock5.png": "4aca",
	"./mega-man/stock6.png": "b3a7",
	"./mega-man/stock7.png": "a665",
	"./meta-knight/avatar0.png": "44b8",
	"./meta-knight/avatar1.png": "7738",
	"./meta-knight/avatar2.png": "1b8d",
	"./meta-knight/avatar3.png": "44f6",
	"./meta-knight/avatar4.png": "4a09",
	"./meta-knight/avatar5.png": "b953",
	"./meta-knight/avatar6.png": "73d6",
	"./meta-knight/avatar7.png": "edaa",
	"./meta-knight/full0-min.png": "5ccd",
	"./meta-knight/full1-min.png": "3eb9",
	"./meta-knight/full2-min.png": "61b1",
	"./meta-knight/full3-min.png": "a329",
	"./meta-knight/full4-min.png": "cde1",
	"./meta-knight/full5-min.png": "e48f",
	"./meta-knight/full6-min.png": "f177",
	"./meta-knight/full7-min.png": "6264",
	"./meta-knight/selected0-min.png": "a8d3",
	"./meta-knight/selected1-min.png": "35e5",
	"./meta-knight/selected2-min.png": "c8bf",
	"./meta-knight/selected3-min.png": "e2e4",
	"./meta-knight/selected4-min.png": "66af",
	"./meta-knight/selected5-min.png": "bce0",
	"./meta-knight/selected6-min.png": "63c2",
	"./meta-knight/selected7-min.png": "4e85",
	"./meta-knight/stock0.png": "bf82",
	"./meta-knight/stock1.png": "ca06",
	"./meta-knight/stock2.png": "55c1",
	"./meta-knight/stock3.png": "b9cf",
	"./meta-knight/stock4.png": "25ab",
	"./meta-knight/stock5.png": "70d5",
	"./meta-knight/stock6.png": "6ab1",
	"./meta-knight/stock7.png": "5be3",
	"./mewtwo/avatar0.png": "5f07",
	"./mewtwo/avatar1.png": "af2a",
	"./mewtwo/avatar2.png": "c5e2",
	"./mewtwo/avatar3.png": "ceca",
	"./mewtwo/avatar4.png": "dc35",
	"./mewtwo/avatar5.png": "da62",
	"./mewtwo/avatar6.png": "21a9",
	"./mewtwo/avatar7.png": "f140",
	"./mewtwo/full0-min.png": "2d7a",
	"./mewtwo/full1-min.png": "02bb",
	"./mewtwo/full2-min.png": "ea6a",
	"./mewtwo/full3-min.png": "4805",
	"./mewtwo/full4-min.png": "a0c3",
	"./mewtwo/full5-min.png": "6aa0",
	"./mewtwo/full6-min.png": "93ee",
	"./mewtwo/full7-min.png": "4fa1",
	"./mewtwo/selected0-min.png": "0ccd",
	"./mewtwo/selected1-min.png": "e366",
	"./mewtwo/selected2-min.png": "26be",
	"./mewtwo/selected3-min.png": "4ecd",
	"./mewtwo/selected4-min.png": "17bd",
	"./mewtwo/selected5-min.png": "7f94",
	"./mewtwo/selected6-min.png": "52b1",
	"./mewtwo/selected7-min.png": "1eac",
	"./mewtwo/stock0.png": "9718",
	"./mewtwo/stock1.png": "420e",
	"./mewtwo/stock2.png": "b41a",
	"./mewtwo/stock3.png": "5262e",
	"./mewtwo/stock4.png": "7eb4",
	"./mewtwo/stock5.png": "5970",
	"./mewtwo/stock6.png": "31b0",
	"./mewtwo/stock7.png": "8fd3",
	"./mii-brawler/full0-min.png": "a076",
	"./mii-brawler/selected0-min.png": "a8f7",
	"./mii-brawler/stock0.png": "a76f",
	"./mii-gunner/full0-min.png": "479c",
	"./mii-gunner/selected0-min.png": "c393",
	"./mii-gunner/stock0.png": "9ff1",
	"./mii-swordfighter/full0-min.png": "ce48",
	"./mii-swordfighter/selected0-min.png": "a9fa",
	"./mii-swordfighter/stock0.png": "edb6",
	"./min-min/avatar0.png": "647e",
	"./min-min/avatar1.png": "d5873",
	"./min-min/avatar2.png": "ed0f",
	"./min-min/avatar3.png": "99cc",
	"./min-min/avatar4.png": "e275",
	"./min-min/avatar5.png": "9cb4",
	"./min-min/avatar6.png": "3b83",
	"./min-min/avatar7.png": "bb95",
	"./min-min/full0-min.png": "d6a0",
	"./min-min/full1-min.png": "a57d",
	"./min-min/full2-min.png": "837f",
	"./min-min/full3-min.png": "77f3",
	"./min-min/full4-min.png": "a72c",
	"./min-min/full5-min.png": "ab39",
	"./min-min/full6-min.png": "9d8a",
	"./min-min/full7-min.png": "33a9",
	"./min-min/selected0-min.png": "77cf",
	"./min-min/selected1-min.png": "d6f9",
	"./min-min/selected2-min.png": "bdfa",
	"./min-min/selected3-min.png": "7dec",
	"./min-min/selected4-min.png": "89a1",
	"./min-min/selected5-min.png": "70cd",
	"./min-min/selected6-min.png": "9d94",
	"./min-min/selected7-min.png": "9c67",
	"./min-min/stock0.png": "0032b",
	"./min-min/stock1.png": "070c",
	"./min-min/stock2.png": "face",
	"./min-min/stock3.png": "6623",
	"./min-min/stock4.png": "b9ad",
	"./min-min/stock5.png": "64c9",
	"./min-min/stock6.png": "23bf",
	"./min-min/stock7.png": "86a6",
	"./mr-game-and-watch/avatar0.png": "0fe1",
	"./mr-game-and-watch/avatar1.png": "31e0",
	"./mr-game-and-watch/avatar2.png": "af8e",
	"./mr-game-and-watch/avatar3.png": "a8fa",
	"./mr-game-and-watch/avatar4.png": "b554",
	"./mr-game-and-watch/avatar5.png": "ce94",
	"./mr-game-and-watch/avatar6.png": "e15d",
	"./mr-game-and-watch/avatar7.png": "7320",
	"./mr-game-and-watch/full0-min.png": "0bec",
	"./mr-game-and-watch/full1-min.png": "8f3b",
	"./mr-game-and-watch/full2-min.png": "40c8",
	"./mr-game-and-watch/full3-min.png": "8c6e",
	"./mr-game-and-watch/full4-min.png": "4e2a",
	"./mr-game-and-watch/full5-min.png": "dc40",
	"./mr-game-and-watch/full6-min.png": "7b9a",
	"./mr-game-and-watch/full7-min.png": "4bee",
	"./mr-game-and-watch/selected0-min.png": "f11a",
	"./mr-game-and-watch/selected1-min.png": "4e5d",
	"./mr-game-and-watch/selected2-min.png": "aeaa",
	"./mr-game-and-watch/selected3-min.png": "f1d6",
	"./mr-game-and-watch/selected4-min.png": "13ef",
	"./mr-game-and-watch/selected5-min.png": "9495",
	"./mr-game-and-watch/selected6-min.png": "f98e",
	"./mr-game-and-watch/selected7-min.png": "3ed0",
	"./mr-game-and-watch/stock0.png": "7b8a",
	"./mr-game-and-watch/stock1.png": "16c4",
	"./mr-game-and-watch/stock2.png": "df1c",
	"./mr-game-and-watch/stock3.png": "4b2f",
	"./mr-game-and-watch/stock4.png": "5d3f",
	"./mr-game-and-watch/stock5.png": "f1b7",
	"./mr-game-and-watch/stock6.png": "5036",
	"./mr-game-and-watch/stock7.png": "0768",
	"./ness/avatar0.png": "1f80",
	"./ness/avatar1.png": "d18e",
	"./ness/avatar2.png": "1004",
	"./ness/avatar3.png": "a2fc",
	"./ness/avatar4.png": "6094",
	"./ness/avatar5.png": "2896",
	"./ness/avatar6.png": "c00d",
	"./ness/avatar7.png": "b412",
	"./ness/full0-min.png": "d150",
	"./ness/full1-min.png": "5f39",
	"./ness/full2-min.png": "517a",
	"./ness/full3-min.png": "ba3c",
	"./ness/full4-min.png": "5845",
	"./ness/full5-min.png": "61b3",
	"./ness/full6-min.png": "e1c9",
	"./ness/full7-min.png": "e6fe",
	"./ness/selected0-min.png": "85b7",
	"./ness/selected1-min.png": "31be",
	"./ness/selected2-min.png": "a34f",
	"./ness/selected3-min.png": "fd63",
	"./ness/selected4-min.png": "b32a",
	"./ness/selected5-min.png": "18f7",
	"./ness/selected6-min.png": "1124",
	"./ness/selected7-min.png": "9dae",
	"./ness/stock0.png": "f0b4",
	"./ness/stock1.png": "bd7e",
	"./ness/stock2.png": "847d",
	"./ness/stock3.png": "d8f9",
	"./ness/stock4.png": "0a6f",
	"./ness/stock5.png": "caf1",
	"./ness/stock6.png": "006c",
	"./ness/stock7.png": "1336",
	"./olimar/avatar0.png": "01b0",
	"./olimar/avatar1.png": "003b",
	"./olimar/avatar2.png": "3548",
	"./olimar/avatar3.png": "e494",
	"./olimar/avatar4.png": "42bd",
	"./olimar/avatar5.png": "c2d94",
	"./olimar/avatar6.png": "19983",
	"./olimar/avatar7.png": "f1ea",
	"./olimar/full0-min.png": "02cc",
	"./olimar/full1-min.png": "869c",
	"./olimar/full2-min.png": "77d81",
	"./olimar/full3-min.png": "e380",
	"./olimar/full4-min.png": "2e51",
	"./olimar/full5-min.png": "df12",
	"./olimar/full6-min.png": "9174",
	"./olimar/full7-min.png": "96cb",
	"./olimar/selected0-min.png": "2508",
	"./olimar/selected1-min.png": "839b",
	"./olimar/selected2-min.png": "fd7a",
	"./olimar/selected3-min.png": "ab68",
	"./olimar/selected4-min.png": "b8c5",
	"./olimar/selected5-min.png": "aa78",
	"./olimar/selected6-min.png": "9fdc",
	"./olimar/selected7-min.png": "892e",
	"./olimar/stock0.png": "9b79",
	"./olimar/stock1.png": "91748",
	"./olimar/stock2.png": "9904",
	"./olimar/stock3.png": "8dd8",
	"./olimar/stock4.png": "5786",
	"./olimar/stock5.png": "0431",
	"./olimar/stock6.png": "06f4",
	"./olimar/stock7.png": "1192",
	"./pac-man/avatar0.png": "07cb",
	"./pac-man/avatar1.png": "4aca7",
	"./pac-man/avatar2.png": "0d34",
	"./pac-man/avatar3.png": "ab60",
	"./pac-man/avatar4.png": "16e9",
	"./pac-man/avatar5.png": "aae1",
	"./pac-man/avatar6.png": "b4eb",
	"./pac-man/avatar7.png": "ef37",
	"./pac-man/full0-min.png": "4820",
	"./pac-man/full1-min.png": "c319",
	"./pac-man/full2-min.png": "cdec",
	"./pac-man/full3-min.png": "4530",
	"./pac-man/full4-min.png": "9ffb",
	"./pac-man/full5-min.png": "ad9a",
	"./pac-man/full6-min.png": "d5b5",
	"./pac-man/full7-min.png": "7fb3",
	"./pac-man/selected0-min.png": "d1cb",
	"./pac-man/selected1-min.png": "8c7c",
	"./pac-man/selected2-min.png": "05f2",
	"./pac-man/selected3-min.png": "01c3",
	"./pac-man/selected4-min.png": "a6da",
	"./pac-man/selected5-min.png": "eace",
	"./pac-man/selected6-min.png": "5d6d",
	"./pac-man/selected7-min.png": "5215",
	"./pac-man/stock0.png": "a123",
	"./pac-man/stock1.png": "8981",
	"./pac-man/stock2.png": "0992",
	"./pac-man/stock3.png": "f044",
	"./pac-man/stock4.png": "b24b",
	"./pac-man/stock5.png": "bfa9",
	"./pac-man/stock6.png": "cab4",
	"./pac-man/stock7.png": "2ffa",
	"./palutena/avatar0.png": "e6be",
	"./palutena/avatar1.png": "6fd6b",
	"./palutena/avatar2.png": "97e7",
	"./palutena/avatar3.png": "8c08",
	"./palutena/avatar4.png": "0b3b",
	"./palutena/avatar5.png": "d64a",
	"./palutena/avatar6.png": "4375",
	"./palutena/avatar7.png": "71a8",
	"./palutena/full0-min.png": "c15f",
	"./palutena/full1-min.png": "0c5b",
	"./palutena/full2-min.png": "68c7",
	"./palutena/full3-min.png": "1b6b",
	"./palutena/full4-min.png": "0f80",
	"./palutena/full5-min.png": "b484",
	"./palutena/full6-min.png": "3aaf",
	"./palutena/full7-min.png": "3c64",
	"./palutena/selected0-min.png": "633c",
	"./palutena/selected1-min.png": "2b69",
	"./palutena/selected2-min.png": "936b",
	"./palutena/selected3-min.png": "55d8",
	"./palutena/selected4-min.png": "24b4",
	"./palutena/selected5-min.png": "27bd",
	"./palutena/selected6-min.png": "14ec",
	"./palutena/selected7-min.png": "f5cd",
	"./palutena/stock0.png": "be67",
	"./palutena/stock1.png": "8ba1",
	"./palutena/stock2.png": "c2bf0",
	"./palutena/stock3.png": "b3c4",
	"./palutena/stock4.png": "594b",
	"./palutena/stock5.png": "0391",
	"./palutena/stock6.png": "22fc",
	"./palutena/stock7.png": "1996",
	"./peach/avatar0.png": "f9ca",
	"./peach/avatar1.png": "c90d",
	"./peach/avatar2.png": "0cf1",
	"./peach/avatar3.png": "809b",
	"./peach/avatar4.png": "d2f2",
	"./peach/avatar5.png": "ce42",
	"./peach/avatar6.png": "d38c",
	"./peach/avatar7.png": "5564",
	"./peach/full0-min.png": "5a4d",
	"./peach/full1-min.png": "459a",
	"./peach/full2-min.png": "d4f1",
	"./peach/full3-min.png": "0fc8",
	"./peach/full4-min.png": "ac3b",
	"./peach/full5-min.png": "db36",
	"./peach/full6-min.png": "5524",
	"./peach/full7-min.png": "1e04",
	"./peach/selected0-min.png": "e34c",
	"./peach/selected1-min.png": "8a08",
	"./peach/selected2-min.png": "3b30",
	"./peach/selected3-min.png": "c8a8",
	"./peach/selected4-min.png": "7c86",
	"./peach/selected5-min.png": "b290",
	"./peach/selected6-min.png": "de7d",
	"./peach/selected7-min.png": "07fe",
	"./peach/stock0.png": "ffce",
	"./peach/stock1.png": "a6786",
	"./peach/stock2.png": "ed30",
	"./peach/stock3.png": "f1c1",
	"./peach/stock4.png": "7246",
	"./peach/stock5.png": "74ff",
	"./peach/stock6.png": "fda5",
	"./peach/stock7.png": "0014",
	"./pichu/avatar0.png": "91bc",
	"./pichu/avatar1.png": "4f93",
	"./pichu/avatar2.png": "e6a9",
	"./pichu/avatar3.png": "5c02",
	"./pichu/avatar4.png": "771c",
	"./pichu/avatar5.png": "21c3",
	"./pichu/avatar6.png": "8478",
	"./pichu/avatar7.png": "9f21",
	"./pichu/full0-min.png": "93d5",
	"./pichu/full1-min.png": "200a",
	"./pichu/full2-min.png": "3875",
	"./pichu/full3-min.png": "e2a3",
	"./pichu/full4-min.png": "b34b",
	"./pichu/full5-min.png": "416c",
	"./pichu/full6-min.png": "8318",
	"./pichu/full7-min.png": "7a92",
	"./pichu/selected0-min.png": "002b",
	"./pichu/selected1-min.png": "305b",
	"./pichu/selected2-min.png": "234a",
	"./pichu/selected3-min.png": "e4b1",
	"./pichu/selected4-min.png": "4153",
	"./pichu/selected5-min.png": "ac23",
	"./pichu/selected6-min.png": "8ff9",
	"./pichu/selected7-min.png": "b7e4",
	"./pichu/stock0.png": "be10",
	"./pichu/stock1.png": "6a44",
	"./pichu/stock2.png": "ca10",
	"./pichu/stock3.png": "9611",
	"./pichu/stock4.png": "42cb",
	"./pichu/stock5.png": "8433",
	"./pichu/stock6.png": "9f30",
	"./pichu/stock7.png": "5d5f",
	"./pikachu/avatar0.png": "149b",
	"./pikachu/avatar1.png": "f53c",
	"./pikachu/avatar2.png": "1753",
	"./pikachu/avatar3.png": "953d",
	"./pikachu/avatar4.png": "82d0",
	"./pikachu/avatar5.png": "fe5d",
	"./pikachu/avatar6.png": "4cfa",
	"./pikachu/avatar7.png": "4546",
	"./pikachu/full0-min.png": "e4fc",
	"./pikachu/full1-min.png": "069a",
	"./pikachu/full2-min.png": "6225",
	"./pikachu/full3-min.png": "8155",
	"./pikachu/full4-min.png": "7cb6",
	"./pikachu/full5-min.png": "5b06",
	"./pikachu/full6-min.png": "25f0a",
	"./pikachu/full7-min.png": "e5db",
	"./pikachu/selected0-min.png": "45e4",
	"./pikachu/selected1-min.png": "002b6",
	"./pikachu/selected2-min.png": "d395",
	"./pikachu/selected3-min.png": "2b46",
	"./pikachu/selected4-min.png": "c4a6",
	"./pikachu/selected5-min.png": "2972",
	"./pikachu/selected6-min.png": "2e04",
	"./pikachu/selected7-min.png": "6d88",
	"./pikachu/stock0.png": "3d0d",
	"./pikachu/stock1.png": "1ed0",
	"./pikachu/stock2.png": "28e0",
	"./pikachu/stock3.png": "115c",
	"./pikachu/stock4.png": "bae1",
	"./pikachu/stock5.png": "0316",
	"./pikachu/stock6.png": "69fd",
	"./pikachu/stock7.png": "8c0a",
	"./piranha-plant/avatar0.png": "ba97",
	"./piranha-plant/avatar1.png": "ead6",
	"./piranha-plant/avatar2.png": "00d2",
	"./piranha-plant/avatar3.png": "cc0c",
	"./piranha-plant/avatar4.png": "28792",
	"./piranha-plant/avatar5.png": "3a59",
	"./piranha-plant/avatar6.png": "eed7",
	"./piranha-plant/avatar7.png": "10e0",
	"./piranha-plant/full0-min.png": "ac36",
	"./piranha-plant/full1-min.png": "a8ac",
	"./piranha-plant/full2-min.png": "6bc8",
	"./piranha-plant/full3-min.png": "d587",
	"./piranha-plant/full4-min.png": "78af",
	"./piranha-plant/full5-min.png": "6d99",
	"./piranha-plant/full6-min.png": "4793",
	"./piranha-plant/full7-min.png": "c9e7",
	"./piranha-plant/selected0-min.png": "e984",
	"./piranha-plant/selected1-min.png": "b86d",
	"./piranha-plant/selected2-min.png": "5853",
	"./piranha-plant/selected3-min.png": "a15c",
	"./piranha-plant/selected4-min.png": "3505",
	"./piranha-plant/selected5-min.png": "de74",
	"./piranha-plant/selected6-min.png": "7229",
	"./piranha-plant/selected7-min.png": "fdfe",
	"./piranha-plant/stock0.png": "6f8c",
	"./piranha-plant/stock1.png": "95c9",
	"./piranha-plant/stock2.png": "c70e",
	"./piranha-plant/stock3.png": "fb11",
	"./piranha-plant/stock4.png": "0938",
	"./piranha-plant/stock5.png": "52ad",
	"./piranha-plant/stock6.png": "f87f",
	"./piranha-plant/stock7.png": "ea1f",
	"./pit/avatar0.png": "c1d3",
	"./pit/avatar1.png": "7867",
	"./pit/avatar2.png": "4611",
	"./pit/avatar3.png": "e2f4",
	"./pit/avatar4.png": "331d",
	"./pit/avatar5.png": "2ec0",
	"./pit/avatar6.png": "9e83",
	"./pit/avatar7.png": "e850",
	"./pit/full0-min.png": "a6ed",
	"./pit/full1-min.png": "8cb0",
	"./pit/full2-min.png": "4bbf",
	"./pit/full3-min.png": "73c3",
	"./pit/full4-min.png": "278d",
	"./pit/full5-min.png": "80f3",
	"./pit/full6-min.png": "76b0",
	"./pit/full7-min.png": "042a",
	"./pit/selected0-min.png": "1bbd",
	"./pit/selected1-min.png": "14c5",
	"./pit/selected2-min.png": "7b27",
	"./pit/selected3-min.png": "4237",
	"./pit/selected4-min.png": "05df",
	"./pit/selected5-min.png": "afcc",
	"./pit/selected6-min.png": "b6eb",
	"./pit/selected7-min.png": "cbea",
	"./pit/stock0.png": "3c84",
	"./pit/stock1.png": "34e2",
	"./pit/stock2.png": "89a6",
	"./pit/stock3.png": "9fff",
	"./pit/stock4.png": "9ce7",
	"./pit/stock5.png": "5f97",
	"./pit/stock6.png": "beb3",
	"./pit/stock7.png": "2f47",
	"./pokemon-trainer/avatar0.png": "6b45",
	"./pokemon-trainer/avatar1.png": "c686",
	"./pokemon-trainer/avatar2.png": "2a8c",
	"./pokemon-trainer/avatar3.png": "f7fe",
	"./pokemon-trainer/avatar4.png": "eac7",
	"./pokemon-trainer/avatar5.png": "8276",
	"./pokemon-trainer/avatar6.png": "ce6e",
	"./pokemon-trainer/avatar7.png": "e44b",
	"./pokemon-trainer/full0-min.png": "9c1d",
	"./pokemon-trainer/full1-min.png": "e457",
	"./pokemon-trainer/full2-min.png": "5afe",
	"./pokemon-trainer/full3-min.png": "37a1",
	"./pokemon-trainer/full4-min.png": "1093",
	"./pokemon-trainer/full5-min.png": "340f",
	"./pokemon-trainer/full6-min.png": "4ab3",
	"./pokemon-trainer/full7-min.png": "5ce3",
	"./pokemon-trainer/selected0-min.png": "d3a8",
	"./pokemon-trainer/selected1-min.png": "cefb",
	"./pokemon-trainer/selected2-min.png": "ade3",
	"./pokemon-trainer/selected3-min.png": "a38d",
	"./pokemon-trainer/selected4-min.png": "0e1f",
	"./pokemon-trainer/selected5-min.png": "28ed",
	"./pokemon-trainer/selected6-min.png": "8daf",
	"./pokemon-trainer/selected7-min.png": "b9b8",
	"./pokemon-trainer/stock0.png": "c477",
	"./pokemon-trainer/stock1.png": "a8df",
	"./pokemon-trainer/stock2.png": "48ef",
	"./pokemon-trainer/stock3.png": "9fa6",
	"./pokemon-trainer/stock4.png": "9404",
	"./pokemon-trainer/stock5.png": "7c3c",
	"./pokemon-trainer/stock6.png": "0d40",
	"./pokemon-trainer/stock7.png": "3061",
	"./pyra-and-mythra/avatar0.png": "deb0",
	"./pyra-and-mythra/avatar1.png": "9737",
	"./pyra-and-mythra/avatar2.png": "07ee",
	"./pyra-and-mythra/avatar3.png": "7bae",
	"./pyra-and-mythra/avatar4.png": "7094",
	"./pyra-and-mythra/avatar5.png": "d56a",
	"./pyra-and-mythra/avatar6.png": "4ada",
	"./pyra-and-mythra/avatar7.png": "72ef",
	"./pyra-and-mythra/full0-min.png": "cf87",
	"./pyra-and-mythra/full1-min.png": "1419",
	"./pyra-and-mythra/full2-min.png": "8770",
	"./pyra-and-mythra/full3-min.png": "a2e1",
	"./pyra-and-mythra/full4-min.png": "5a2d",
	"./pyra-and-mythra/full5-min.png": "61d0",
	"./pyra-and-mythra/full6-min.png": "8e1e",
	"./pyra-and-mythra/full7-min.png": "e74e",
	"./pyra-and-mythra/selected0-min.png": "029e",
	"./pyra-and-mythra/selected1-min.png": "0c62",
	"./pyra-and-mythra/selected2-min.png": "a0be",
	"./pyra-and-mythra/selected3-min.png": "784e",
	"./pyra-and-mythra/selected4-min.png": "b125",
	"./pyra-and-mythra/selected5-min.png": "ec76",
	"./pyra-and-mythra/selected6-min.png": "05c8",
	"./pyra-and-mythra/selected7-min.png": "d8ce",
	"./pyra-and-mythra/stock0.png": "10b0",
	"./pyra-and-mythra/stock1.png": "0a74",
	"./pyra-and-mythra/stock10.png": "0c8d",
	"./pyra-and-mythra/stock11.png": "63ad",
	"./pyra-and-mythra/stock12.png": "5cd3",
	"./pyra-and-mythra/stock13.png": "c792",
	"./pyra-and-mythra/stock14.png": "8081",
	"./pyra-and-mythra/stock15.png": "9138",
	"./pyra-and-mythra/stock2.png": "f10e",
	"./pyra-and-mythra/stock3.png": "8e50",
	"./pyra-and-mythra/stock4.png": "955f2",
	"./pyra-and-mythra/stock5.png": "6a57",
	"./pyra-and-mythra/stock6.png": "8d64",
	"./pyra-and-mythra/stock7.png": "4c16",
	"./pyra-and-mythra/stock8.png": "4524",
	"./pyra-and-mythra/stock9.png": "7492",
	"./richter/avatar0.png": "5b642",
	"./richter/avatar1.png": "bcb9",
	"./richter/avatar2.png": "e9ad",
	"./richter/avatar3.png": "3417",
	"./richter/avatar4.png": "e2d9",
	"./richter/avatar5.png": "53ee",
	"./richter/avatar6.png": "6fc0",
	"./richter/avatar7.png": "d85a",
	"./richter/full0-min.png": "161d",
	"./richter/full1-min.png": "7806",
	"./richter/full2-min.png": "c04a",
	"./richter/full3-min.png": "2bd1",
	"./richter/full4-min.png": "6387",
	"./richter/full5-min.png": "1ba8",
	"./richter/full6-min.png": "89b7",
	"./richter/full7-min.png": "cc3e",
	"./richter/selected0-min.png": "b829",
	"./richter/selected1-min.png": "b743",
	"./richter/selected2-min.png": "71ed",
	"./richter/selected3-min.png": "9977",
	"./richter/selected4-min.png": "edb2",
	"./richter/selected5-min.png": "f15c",
	"./richter/selected6-min.png": "6011",
	"./richter/selected7-min.png": "9a0e",
	"./richter/stock0.png": "73f7",
	"./richter/stock1.png": "c6c1",
	"./richter/stock2.png": "2141",
	"./richter/stock3.png": "be7f",
	"./richter/stock4.png": "9d1a",
	"./richter/stock5.png": "8595",
	"./richter/stock6.png": "463e",
	"./richter/stock7.png": "a6ec",
	"./ridley/avatar0.png": "29cd",
	"./ridley/avatar1.png": "4273",
	"./ridley/avatar2.png": "0e1fb",
	"./ridley/avatar3.png": "5ae5",
	"./ridley/avatar4.png": "f163",
	"./ridley/avatar5.png": "8d7a",
	"./ridley/avatar6.png": "e34d",
	"./ridley/avatar7.png": "3b1e",
	"./ridley/full0-min.png": "ea26",
	"./ridley/full1-min.png": "a74d",
	"./ridley/full2-min.png": "230d",
	"./ridley/full3-min.png": "e98c",
	"./ridley/full4-min.png": "31b8",
	"./ridley/full5-min.png": "dd2f",
	"./ridley/full6-min.png": "fa1f",
	"./ridley/full7-min.png": "6f77",
	"./ridley/selected0-min.png": "8b8c",
	"./ridley/selected1-min.png": "fc0b",
	"./ridley/selected2-min.png": "b55c",
	"./ridley/selected3-min.png": "e0cc",
	"./ridley/selected4-min.png": "9a01",
	"./ridley/selected5-min.png": "7c76",
	"./ridley/selected6-min.png": "ed3c",
	"./ridley/selected7-min.png": "70aa",
	"./ridley/stock0.png": "3066",
	"./ridley/stock1.png": "09c2",
	"./ridley/stock2.png": "dc6f",
	"./ridley/stock3.png": "f7c9",
	"./ridley/stock4.png": "b72a",
	"./ridley/stock5.png": "8f7f",
	"./ridley/stock6.png": "4e22",
	"./ridley/stock7.png": "91a1",
	"./rob/avatar0.png": "91c3",
	"./rob/avatar1.png": "4c91",
	"./rob/avatar2.png": "0fff",
	"./rob/avatar3.png": "4930",
	"./rob/avatar4.png": "3de4",
	"./rob/avatar5.png": "92a3",
	"./rob/avatar6.png": "5ca8",
	"./rob/avatar7.png": "400e",
	"./rob/full0-min.png": "c22d",
	"./rob/full1-min.png": "59c3",
	"./rob/full2-min.png": "d6dc",
	"./rob/full3-min.png": "131f",
	"./rob/full4-min.png": "0517",
	"./rob/full5-min.png": "6316",
	"./rob/full6-min.png": "728b",
	"./rob/full7-min.png": "8caa",
	"./rob/selected0-min.png": "c946",
	"./rob/selected1-min.png": "5ba5",
	"./rob/selected2-min.png": "263a",
	"./rob/selected3-min.png": "7c865",
	"./rob/selected4-min.png": "fe66",
	"./rob/selected5-min.png": "0494",
	"./rob/selected6-min.png": "c5d6",
	"./rob/selected7-min.png": "c572",
	"./rob/stock0.png": "9738",
	"./rob/stock1.png": "8cb7",
	"./rob/stock2.png": "65d9",
	"./rob/stock3.png": "3b2a",
	"./rob/stock4.png": "b264",
	"./rob/stock5.png": "369b",
	"./rob/stock6.png": "d983",
	"./rob/stock7.png": "a189",
	"./robin/avatar0.png": "be32d",
	"./robin/avatar1.png": "0ee0",
	"./robin/avatar2.png": "2b1b",
	"./robin/avatar3.png": "6cf2",
	"./robin/avatar4.png": "b1ad",
	"./robin/avatar5.png": "db97",
	"./robin/avatar6.png": "b318",
	"./robin/avatar7.png": "53eb",
	"./robin/full0-min.png": "ed7f",
	"./robin/full1-min.png": "b151",
	"./robin/full2-min.png": "6e79",
	"./robin/full3-min.png": "a539",
	"./robin/full4-min.png": "663c",
	"./robin/full5-min.png": "0355",
	"./robin/full6-min.png": "fd86",
	"./robin/full7-min.png": "cb0e",
	"./robin/selected0-min.png": "134f",
	"./robin/selected1-min.png": "14fd",
	"./robin/selected2-min.png": "f7c3",
	"./robin/selected3-min.png": "6114",
	"./robin/selected4-min.png": "c675",
	"./robin/selected5-min.png": "a239",
	"./robin/selected6-min.png": "be97",
	"./robin/selected7-min.png": "e1ae",
	"./robin/stock0.png": "eed9",
	"./robin/stock1.png": "08a2",
	"./robin/stock2.png": "d878",
	"./robin/stock3.png": "79e0",
	"./robin/stock4.png": "70d2",
	"./robin/stock5.png": "d928",
	"./robin/stock6.png": "5b17",
	"./robin/stock7.png": "510d",
	"./rosalina-and-luma/avatar0.png": "1028",
	"./rosalina-and-luma/avatar1.png": "0dfe",
	"./rosalina-and-luma/avatar2.png": "223b",
	"./rosalina-and-luma/avatar3.png": "c5ec",
	"./rosalina-and-luma/avatar4.png": "1207",
	"./rosalina-and-luma/avatar5.png": "59e2",
	"./rosalina-and-luma/avatar6.png": "666a",
	"./rosalina-and-luma/avatar7.png": "626d",
	"./rosalina-and-luma/full0-min.png": "a94e",
	"./rosalina-and-luma/full1-min.png": "06e5",
	"./rosalina-and-luma/full2-min.png": "3aa3",
	"./rosalina-and-luma/full3-min.png": "e9d1",
	"./rosalina-and-luma/full4-min.png": "ca48",
	"./rosalina-and-luma/full5-min.png": "de9d",
	"./rosalina-and-luma/full6-min.png": "e597",
	"./rosalina-and-luma/full7-min.png": "527c",
	"./rosalina-and-luma/selected0-min.png": "e5e50",
	"./rosalina-and-luma/selected1-min.png": "906b",
	"./rosalina-and-luma/selected2-min.png": "dc74",
	"./rosalina-and-luma/selected3-min.png": "0084",
	"./rosalina-and-luma/selected4-min.png": "e1bb",
	"./rosalina-and-luma/selected5-min.png": "bc20",
	"./rosalina-and-luma/selected6-min.png": "38ce",
	"./rosalina-and-luma/selected7-min.png": "be2e",
	"./rosalina-and-luma/stock0.png": "b79f",
	"./rosalina-and-luma/stock1.png": "34c3",
	"./rosalina-and-luma/stock2.png": "b2d41",
	"./rosalina-and-luma/stock3.png": "3ae4",
	"./rosalina-and-luma/stock4.png": "1e07",
	"./rosalina-and-luma/stock5.png": "ec60b",
	"./rosalina-and-luma/stock6.png": "a081",
	"./rosalina-and-luma/stock7.png": "ab4a",
	"./roy/avatar0.png": "ce95",
	"./roy/avatar1.png": "49bc",
	"./roy/avatar2.png": "efca",
	"./roy/avatar3.png": "1b00",
	"./roy/avatar4.png": "a09b",
	"./roy/avatar5.png": "f568d",
	"./roy/avatar6.png": "6372",
	"./roy/avatar7.png": "1a16",
	"./roy/full0-min.png": "31d0",
	"./roy/full1-min.png": "b686",
	"./roy/full2-min.png": "1b2b",
	"./roy/full3-min.png": "5a24",
	"./roy/full4-min.png": "22ec",
	"./roy/full5-min.png": "f216",
	"./roy/full6-min.png": "fa83",
	"./roy/full7-min.png": "e4b2",
	"./roy/selected0-min.png": "15c7",
	"./roy/selected1-min.png": "4025",
	"./roy/selected2-min.png": "2943",
	"./roy/selected3-min.png": "d16c",
	"./roy/selected4-min.png": "70d9",
	"./roy/selected5-min.png": "96a7",
	"./roy/selected6-min.png": "6718",
	"./roy/selected7-min.png": "a419",
	"./roy/stock0.png": "fa9f",
	"./roy/stock1.png": "2930",
	"./roy/stock2.png": "f256",
	"./roy/stock3.png": "61f9",
	"./roy/stock4.png": "c4b4",
	"./roy/stock5.png": "2de2",
	"./roy/stock6.png": "1de0",
	"./roy/stock7.png": "6ca1",
	"./ryu/avatar0.png": "26f6",
	"./ryu/avatar1.png": "554c",
	"./ryu/avatar2.png": "7caf",
	"./ryu/avatar3.png": "1968",
	"./ryu/avatar4.png": "593b",
	"./ryu/avatar5.png": "5e71",
	"./ryu/avatar6.png": "49b2",
	"./ryu/avatar7.png": "e47c",
	"./ryu/full0-min.png": "7850",
	"./ryu/full1-min.png": "803f",
	"./ryu/full2-min.png": "d8fa",
	"./ryu/full3-min.png": "3bae",
	"./ryu/full4-min.png": "5d8c",
	"./ryu/full5-min.png": "29d6",
	"./ryu/full6-min.png": "a2a4",
	"./ryu/full7-min.png": "bb66",
	"./ryu/selected0-min.png": "d813",
	"./ryu/selected1-min.png": "c782",
	"./ryu/selected2-min.png": "ae9a",
	"./ryu/selected3-min.png": "9416",
	"./ryu/selected4-min.png": "be47",
	"./ryu/selected5-min.png": "c52d",
	"./ryu/selected6-min.png": "6118",
	"./ryu/selected7-min.png": "0e74",
	"./ryu/stock0.png": "eb8a",
	"./ryu/stock1.png": "8e80",
	"./ryu/stock2.png": "5acb",
	"./ryu/stock3.png": "a407",
	"./ryu/stock4.png": "7b14",
	"./ryu/stock5.png": "77d5",
	"./ryu/stock6.png": "ef3c",
	"./ryu/stock7.png": "682b",
	"./samus/avatar0.png": "e2fa",
	"./samus/avatar1.png": "a004",
	"./samus/avatar2.png": "fd20",
	"./samus/avatar3.png": "1d6b",
	"./samus/avatar4.png": "79e6",
	"./samus/avatar5.png": "d035",
	"./samus/avatar6.png": "a803",
	"./samus/avatar7.png": "1870",
	"./samus/full0-min.png": "6d19",
	"./samus/full1-min.png": "4a8a",
	"./samus/full2-min.png": "6604",
	"./samus/full3-min.png": "3744",
	"./samus/full4-min.png": "a1e9",
	"./samus/full5-min.png": "37b0",
	"./samus/full6-min.png": "fef1",
	"./samus/full7-min.png": "a1f0",
	"./samus/selected0-min.png": "6e42",
	"./samus/selected1-min.png": "74b2",
	"./samus/selected2-min.png": "cb57",
	"./samus/selected3-min.png": "b299",
	"./samus/selected4-min.png": "2da5",
	"./samus/selected5-min.png": "1b1b",
	"./samus/selected6-min.png": "1844",
	"./samus/selected7-min.png": "341e",
	"./samus/stock0.png": "16b7",
	"./samus/stock1.png": "2ac6",
	"./samus/stock2.png": "ab47",
	"./samus/stock3.png": "5a46",
	"./samus/stock4.png": "0d515",
	"./samus/stock5.png": "1fc7",
	"./samus/stock6.png": "be1f",
	"./samus/stock7.png": "130d",
	"./sephiroth/avatar0.png": "30e3",
	"./sephiroth/avatar1.png": "0b98",
	"./sephiroth/avatar2.png": "dbd1",
	"./sephiroth/avatar3.png": "bb92",
	"./sephiroth/avatar4.png": "0303",
	"./sephiroth/avatar5.png": "6a8a",
	"./sephiroth/avatar6.png": "bbfe",
	"./sephiroth/avatar7.png": "2a60",
	"./sephiroth/full0-min.png": "5143",
	"./sephiroth/full1-min.png": "60d6",
	"./sephiroth/full2-min.png": "b7a5",
	"./sephiroth/full3-min.png": "c4fa",
	"./sephiroth/full4-min.png": "d515",
	"./sephiroth/full5-min.png": "9166",
	"./sephiroth/full6-min.png": "b323",
	"./sephiroth/full7-min.png": "5a50",
	"./sephiroth/selected0-min.png": "f10d",
	"./sephiroth/selected1-min.png": "b1e1",
	"./sephiroth/selected2-min.png": "7db3",
	"./sephiroth/selected3-min.png": "d77e",
	"./sephiroth/selected4-min.png": "9c18",
	"./sephiroth/selected5-min.png": "59fa",
	"./sephiroth/selected6-min.png": "6522",
	"./sephiroth/selected7-min.png": "ff99",
	"./sephiroth/stock0.png": "bab7",
	"./sephiroth/stock1.png": "e05a",
	"./sephiroth/stock2.png": "8eb9",
	"./sephiroth/stock3.png": "b332",
	"./sephiroth/stock4.png": "ae45",
	"./sephiroth/stock5.png": "a18c",
	"./sephiroth/stock6.png": "7a91",
	"./sephiroth/stock7.png": "98e4",
	"./sheik/avatar0.png": "26c8",
	"./sheik/avatar1.png": "7357",
	"./sheik/avatar2.png": "04b4",
	"./sheik/avatar3.png": "5de1",
	"./sheik/avatar4.png": "c833",
	"./sheik/avatar5.png": "115a",
	"./sheik/avatar6.png": "28d2",
	"./sheik/avatar7.png": "e553",
	"./sheik/full0-min.png": "f031",
	"./sheik/full1-min.png": "e89d",
	"./sheik/full2-min.png": "2fc5",
	"./sheik/full3-min.png": "d154",
	"./sheik/full4-min.png": "f99d",
	"./sheik/full5-min.png": "7e30",
	"./sheik/full6-min.png": "94e0",
	"./sheik/full7-min.png": "61d7",
	"./sheik/selected0-min.png": "3fe3",
	"./sheik/selected1-min.png": "41d9",
	"./sheik/selected2-min.png": "71a0",
	"./sheik/selected3-min.png": "b8c58",
	"./sheik/selected4-min.png": "1eb4",
	"./sheik/selected5-min.png": "315b",
	"./sheik/selected6-min.png": "69b5",
	"./sheik/selected7-min.png": "4eb8",
	"./sheik/stock0.png": "dd58",
	"./sheik/stock1.png": "41e4",
	"./sheik/stock2.png": "0abe",
	"./sheik/stock3.png": "08ae",
	"./sheik/stock4.png": "5f4c",
	"./sheik/stock5.png": "b43a",
	"./sheik/stock6.png": "6f78",
	"./sheik/stock7.png": "a37f",
	"./shulk/avatar0.png": "dfb3",
	"./shulk/avatar1.png": "9091",
	"./shulk/avatar2.png": "0ae1",
	"./shulk/avatar3.png": "ac15",
	"./shulk/avatar4.png": "c001",
	"./shulk/avatar5.png": "c291",
	"./shulk/avatar6.png": "ef80",
	"./shulk/avatar7.png": "9aa7",
	"./shulk/full0-min.png": "183f",
	"./shulk/full1-min.png": "42cd",
	"./shulk/full2-min.png": "2303",
	"./shulk/full3-min.png": "8ea0",
	"./shulk/full4-min.png": "2bba",
	"./shulk/full5-min.png": "02ef",
	"./shulk/full6-min.png": "7789",
	"./shulk/full7-min.png": "9a62",
	"./shulk/selected0-min.png": "9b9b",
	"./shulk/selected1-min.png": "0921",
	"./shulk/selected2-min.png": "2523",
	"./shulk/selected3-min.png": "8586",
	"./shulk/selected4-min.png": "b1be",
	"./shulk/selected5-min.png": "ad93",
	"./shulk/selected6-min.png": "d629",
	"./shulk/selected7-min.png": "c698",
	"./shulk/stock0.png": "7279",
	"./shulk/stock1.png": "a7a5",
	"./shulk/stock2.png": "a1e1",
	"./shulk/stock3.png": "120e",
	"./shulk/stock4.png": "953a",
	"./shulk/stock5.png": "1b69",
	"./shulk/stock6.png": "0877",
	"./shulk/stock7.png": "1e7b",
	"./simon/avatar0.png": "3bed",
	"./simon/avatar1.png": "ca1a",
	"./simon/avatar2.png": "201f",
	"./simon/avatar3.png": "5301",
	"./simon/avatar4.png": "c54e",
	"./simon/avatar5.png": "05fd",
	"./simon/avatar6.png": "72f1",
	"./simon/avatar7.png": "76dd",
	"./simon/full0-min.png": "edcb",
	"./simon/full1-min.png": "ecfe",
	"./simon/full2-min.png": "e7be",
	"./simon/full3-min.png": "a8ac1",
	"./simon/full4-min.png": "a678",
	"./simon/full5-min.png": "0e5e",
	"./simon/full6-min.png": "af35",
	"./simon/full7-min.png": "a909",
	"./simon/selected0-min.png": "3852",
	"./simon/selected1-min.png": "13a3",
	"./simon/selected2-min.png": "1bd00",
	"./simon/selected3-min.png": "17fd",
	"./simon/selected4-min.png": "9fb08",
	"./simon/selected5-min.png": "fe3e",
	"./simon/selected6-min.png": "aa53",
	"./simon/selected7-min.png": "106c",
	"./simon/stock0.png": "6225d",
	"./simon/stock1.png": "2253",
	"./simon/stock2.png": "7d43",
	"./simon/stock3.png": "e88f",
	"./simon/stock4.png": "c8333",
	"./simon/stock5.png": "4200",
	"./simon/stock6.png": "ed15",
	"./simon/stock7.png": "853a",
	"./snake/avatar0.png": "b6ebf",
	"./snake/avatar1.png": "c05d",
	"./snake/avatar2.png": "f5dfe",
	"./snake/avatar3.png": "85a4",
	"./snake/avatar4.png": "24fb",
	"./snake/avatar5.png": "b20c",
	"./snake/avatar6.png": "1e185",
	"./snake/avatar7.png": "fade",
	"./snake/full0-min.png": "a9e6",
	"./snake/full1-min.png": "8357",
	"./snake/full2-min.png": "8007",
	"./snake/full3-min.png": "5e2d",
	"./snake/full4-min.png": "ccfb",
	"./snake/full5-min.png": "a44f",
	"./snake/full6-min.png": "4035",
	"./snake/full7-min.png": "fa0f",
	"./snake/selected0-min.png": "d547",
	"./snake/selected1-min.png": "eb58",
	"./snake/selected2-min.png": "3d89",
	"./snake/selected3-min.png": "a32f",
	"./snake/selected4-min.png": "a74f",
	"./snake/selected5-min.png": "f92e",
	"./snake/selected6-min.png": "9432",
	"./snake/selected7-min.png": "5123",
	"./snake/stock0.png": "3c82",
	"./snake/stock1.png": "b883",
	"./snake/stock2.png": "d5b9",
	"./snake/stock3.png": "048b",
	"./snake/stock4.png": "989f",
	"./snake/stock5.png": "192b",
	"./snake/stock6.png": "e4e6",
	"./snake/stock7.png": "14e1",
	"./sonic/avatar0.png": "67b0",
	"./sonic/avatar1.png": "630f",
	"./sonic/avatar2.png": "9256",
	"./sonic/avatar3.png": "ec16",
	"./sonic/avatar4.png": "4387",
	"./sonic/avatar5.png": "142c",
	"./sonic/avatar6.png": "044b",
	"./sonic/avatar7.png": "1f3a",
	"./sonic/full0-min.png": "8dd0",
	"./sonic/full1-min.png": "f875",
	"./sonic/full2-min.png": "366b",
	"./sonic/full3-min.png": "9d62",
	"./sonic/full4-min.png": "7397",
	"./sonic/full5-min.png": "4a6f",
	"./sonic/full6-min.png": "0859",
	"./sonic/full7-min.png": "0d89",
	"./sonic/selected0-min.png": "9b02",
	"./sonic/selected1-min.png": "0c47",
	"./sonic/selected2-min.png": "9a06",
	"./sonic/selected3-min.png": "0236",
	"./sonic/selected4-min.png": "7a2f",
	"./sonic/selected5-min.png": "9754",
	"./sonic/selected6-min.png": "21d0",
	"./sonic/selected7-min.png": "8fc7",
	"./sonic/stock0.png": "2cfb",
	"./sonic/stock1.png": "23ca",
	"./sonic/stock2.png": "a4c2",
	"./sonic/stock3.png": "a278",
	"./sonic/stock4.png": "b1259",
	"./sonic/stock5.png": "d22f",
	"./sonic/stock6.png": "0732",
	"./sonic/stock7.png": "a95e",
	"./sora/avatar0.png": "9c436",
	"./sora/avatar1.png": "e512",
	"./sora/avatar2.png": "847a",
	"./sora/avatar3.png": "4410",
	"./sora/avatar4.png": "f6fc",
	"./sora/avatar5.png": "cb800",
	"./sora/avatar6.png": "77df",
	"./sora/avatar7.png": "1470",
	"./sora/full0-min.png": "9271",
	"./sora/full1-min.png": "f221",
	"./sora/full2-min.png": "0d26",
	"./sora/full3-min.png": "9013",
	"./sora/full4-min.png": "129a",
	"./sora/full5-min.png": "bc53",
	"./sora/full6-min.png": "cc22",
	"./sora/full7-min.png": "0f4e",
	"./sora/selected0-min.png": "28c3",
	"./sora/selected1-min.png": "354f",
	"./sora/selected2-min.png": "7315",
	"./sora/selected3-min.png": "88b5",
	"./sora/selected4-min.png": "ed7e",
	"./sora/selected5-min.png": "43c9",
	"./sora/selected6-min.png": "4d0e",
	"./sora/selected7-min.png": "0423",
	"./sora/stock0.png": "38d2",
	"./sora/stock1.png": "0670",
	"./sora/stock2.png": "b29d",
	"./sora/stock3.png": "83d7",
	"./sora/stock4.png": "3787",
	"./sora/stock5.png": "16ba",
	"./sora/stock6.png": "da1e",
	"./sora/stock7.png": "488a",
	"./steve/avatar0.png": "47c6",
	"./steve/avatar1.png": "e2a1",
	"./steve/avatar2.png": "9741",
	"./steve/avatar3.png": "f775",
	"./steve/avatar4.png": "521c",
	"./steve/avatar5.png": "373a",
	"./steve/avatar6.png": "deec",
	"./steve/avatar7.png": "e9d6",
	"./steve/full0-min.png": "1a32",
	"./steve/full1-min.png": "f999",
	"./steve/full2-min.png": "1843",
	"./steve/full3-min.png": "e36d",
	"./steve/full4-min.png": "3b95",
	"./steve/full5-min.png": "288d",
	"./steve/full6-min.png": "7349",
	"./steve/full7-min.png": "0cbe",
	"./steve/selected0-min.png": "b338",
	"./steve/selected1-min.png": "3457",
	"./steve/selected2-min.png": "021b",
	"./steve/selected3-min.png": "74fe",
	"./steve/selected4-min.png": "66d1",
	"./steve/selected5-min.png": "8597",
	"./steve/selected6-min.png": "9181",
	"./steve/selected7-min.png": "3eed",
	"./steve/stock0.png": "cc81",
	"./steve/stock1.png": "0698",
	"./steve/stock2.png": "97e8",
	"./steve/stock3.png": "6847",
	"./steve/stock4.png": "3c43",
	"./steve/stock5.png": "c42e",
	"./steve/stock6.png": "de57",
	"./steve/stock7.png": "1a02",
	"./terry/avatar0.png": "a2a0",
	"./terry/avatar1.png": "1392",
	"./terry/avatar2.png": "9f16",
	"./terry/avatar3.png": "368d",
	"./terry/avatar4.png": "8579",
	"./terry/avatar5.png": "59f6",
	"./terry/avatar6.png": "2adb",
	"./terry/avatar7.png": "6dda",
	"./terry/full0-min.png": "6bc2",
	"./terry/full1-min.png": "6a06",
	"./terry/full2-min.png": "e26e",
	"./terry/full3-min.png": "f23d",
	"./terry/full4-min.png": "bb27",
	"./terry/full5-min.png": "f670",
	"./terry/full6-min.png": "a7ec",
	"./terry/full7-min.png": "96c5",
	"./terry/selected0-min.png": "24c7",
	"./terry/selected1-min.png": "a3bc",
	"./terry/selected2-min.png": "c4b7",
	"./terry/selected3-min.png": "1084",
	"./terry/selected4-min.png": "d609",
	"./terry/selected5-min.png": "7af7",
	"./terry/selected6-min.png": "d392",
	"./terry/selected7-min.png": "0c6f",
	"./terry/stock0.png": "11fa",
	"./terry/stock1.png": "df47",
	"./terry/stock2.png": "985e",
	"./terry/stock3.png": "0637",
	"./terry/stock4.png": "034f",
	"./terry/stock5.png": "e047",
	"./terry/stock6.png": "dcdf",
	"./terry/stock7.png": "466d",
	"./toon-link/avatar0.png": "188a",
	"./toon-link/avatar1.png": "364c",
	"./toon-link/avatar2.png": "246e",
	"./toon-link/avatar3.png": "4e98",
	"./toon-link/avatar4.png": "f186",
	"./toon-link/avatar5.png": "1f02",
	"./toon-link/avatar6.png": "ee7b4",
	"./toon-link/avatar7.png": "1f1f",
	"./toon-link/full0-min.png": "e0eb",
	"./toon-link/full1-min.png": "87c9",
	"./toon-link/full2-min.png": "6591",
	"./toon-link/full3-min.png": "fcd5",
	"./toon-link/full4-min.png": "0b38",
	"./toon-link/full5-min.png": "80a8",
	"./toon-link/full6-min.png": "361f",
	"./toon-link/full7-min.png": "bbb4",
	"./toon-link/selected0-min.png": "4ce1",
	"./toon-link/selected1-min.png": "8ce9",
	"./toon-link/selected2-min.png": "e4e1",
	"./toon-link/selected3-min.png": "a07d",
	"./toon-link/selected4-min.png": "6fd6",
	"./toon-link/selected5-min.png": "8a12",
	"./toon-link/selected6-min.png": "4d5e",
	"./toon-link/selected7-min.png": "85dd",
	"./toon-link/stock0.png": "f349",
	"./toon-link/stock1.png": "3ede",
	"./toon-link/stock2.png": "34af",
	"./toon-link/stock3.png": "c923",
	"./toon-link/stock4.png": "87a2",
	"./toon-link/stock5.png": "fc79",
	"./toon-link/stock6.png": "0add",
	"./toon-link/stock7.png": "774c",
	"./villager/avatar0.png": "45ed",
	"./villager/avatar1.png": "1bc3",
	"./villager/avatar2.png": "22d8",
	"./villager/avatar3.png": "1253",
	"./villager/avatar4.png": "6742",
	"./villager/avatar5.png": "fc75",
	"./villager/avatar6.png": "64a7",
	"./villager/avatar7.png": "5805",
	"./villager/full0-min.png": "9405",
	"./villager/full1-min.png": "86e8",
	"./villager/full2-min.png": "344f",
	"./villager/full3-min.png": "1ef6",
	"./villager/full4-min.png": "ed40",
	"./villager/full5-min.png": "cfdd",
	"./villager/full6-min.png": "01227",
	"./villager/full7-min.png": "99fa",
	"./villager/selected0-min.png": "d338",
	"./villager/selected1-min.png": "6f14",
	"./villager/selected2-min.png": "3a8f",
	"./villager/selected3-min.png": "e2a3c",
	"./villager/selected4-min.png": "bf0b",
	"./villager/selected5-min.png": "9e38",
	"./villager/selected6-min.png": "346a",
	"./villager/selected7-min.png": "d6c8",
	"./villager/stock0.png": "e70d",
	"./villager/stock1.png": "ec8d",
	"./villager/stock2.png": "771a",
	"./villager/stock3.png": "deca",
	"./villager/stock4.png": "0321",
	"./villager/stock5.png": "da8c",
	"./villager/stock6.png": "9bda",
	"./villager/stock7.png": "cf82",
	"./wario/avatar0.png": "a6ad",
	"./wario/avatar1.png": "f0fd",
	"./wario/avatar2.png": "5cdd",
	"./wario/avatar3.png": "292c",
	"./wario/avatar4.png": "5b1e",
	"./wario/avatar5.png": "76a8",
	"./wario/avatar6.png": "72d5",
	"./wario/avatar7.png": "546c",
	"./wario/full0-min.png": "b811",
	"./wario/full1-min.png": "af03",
	"./wario/full2-min.png": "6d35",
	"./wario/full3-min.png": "e8aa",
	"./wario/full4-min.png": "617e",
	"./wario/full5-min.png": "096f",
	"./wario/full6-min.png": "93fe",
	"./wario/full7-min.png": "eb73",
	"./wario/selected0-min.png": "79a8",
	"./wario/selected1-min.png": "b932",
	"./wario/selected2-min.png": "45fd",
	"./wario/selected3-min.png": "42ba",
	"./wario/selected4-min.png": "1732",
	"./wario/selected5-min.png": "c5fe",
	"./wario/selected6-min.png": "8283",
	"./wario/selected7-min.png": "5e18",
	"./wario/stock0.png": "38e7",
	"./wario/stock1.png": "9d4a",
	"./wario/stock2.png": "f933",
	"./wario/stock3.png": "3a4e",
	"./wario/stock4.png": "5be1",
	"./wario/stock5.png": "798d",
	"./wario/stock6.png": "4b676",
	"./wario/stock7.png": "97f1",
	"./wii-fit-trainer/avatar0.png": "66a1",
	"./wii-fit-trainer/avatar1.png": "1796",
	"./wii-fit-trainer/avatar2.png": "d72d",
	"./wii-fit-trainer/avatar3.png": "b7ba",
	"./wii-fit-trainer/avatar4.png": "909c",
	"./wii-fit-trainer/avatar5.png": "79ab",
	"./wii-fit-trainer/avatar6.png": "07cb0",
	"./wii-fit-trainer/avatar7.png": "b29c",
	"./wii-fit-trainer/full0-min.png": "85a2",
	"./wii-fit-trainer/full1-min.png": "1e17",
	"./wii-fit-trainer/full2-min.png": "454b",
	"./wii-fit-trainer/full3-min.png": "7c9c",
	"./wii-fit-trainer/full4-min.png": "d60c",
	"./wii-fit-trainer/full5-min.png": "4939",
	"./wii-fit-trainer/full6-min.png": "209a",
	"./wii-fit-trainer/full7-min.png": "899c",
	"./wii-fit-trainer/selected0-min.png": "6f9e",
	"./wii-fit-trainer/selected1-min.png": "d0ae",
	"./wii-fit-trainer/selected2-min.png": "f184",
	"./wii-fit-trainer/selected3-min.png": "3ac9",
	"./wii-fit-trainer/selected4-min.png": "69e9",
	"./wii-fit-trainer/selected5-min.png": "0ae2",
	"./wii-fit-trainer/selected6-min.png": "c9df",
	"./wii-fit-trainer/selected7-min.png": "a7fb",
	"./wii-fit-trainer/stock0.png": "2fd9",
	"./wii-fit-trainer/stock1.png": "5020",
	"./wii-fit-trainer/stock2.png": "ba1b",
	"./wii-fit-trainer/stock3.png": "94b7",
	"./wii-fit-trainer/stock4.png": "ff86",
	"./wii-fit-trainer/stock5.png": "e9f1",
	"./wii-fit-trainer/stock6.png": "d8fa7",
	"./wii-fit-trainer/stock7.png": "3105",
	"./wolf/avatar0.png": "d61c",
	"./wolf/avatar1.png": "fc3c",
	"./wolf/avatar2.png": "1484",
	"./wolf/avatar3.png": "4649",
	"./wolf/avatar4.png": "63b7",
	"./wolf/avatar5.png": "e332",
	"./wolf/avatar6.png": "0be0",
	"./wolf/avatar7.png": "0472",
	"./wolf/full0-min.png": "a9d2",
	"./wolf/full1-min.png": "5453",
	"./wolf/full2-min.png": "1a3c",
	"./wolf/full3-min.png": "9259",
	"./wolf/full4-min.png": "2af8",
	"./wolf/full5-min.png": "76c4",
	"./wolf/full6-min.png": "0450",
	"./wolf/full7-min.png": "d3f0",
	"./wolf/selected0-min.png": "3c70",
	"./wolf/selected1-min.png": "a4f8",
	"./wolf/selected2-min.png": "ec3b",
	"./wolf/selected3-min.png": "28f5",
	"./wolf/selected4-min.png": "0c72",
	"./wolf/selected5-min.png": "04b6",
	"./wolf/selected6-min.png": "1044",
	"./wolf/selected7-min.png": "4a9d",
	"./wolf/stock0.png": "0eac",
	"./wolf/stock1.png": "4c39",
	"./wolf/stock2.png": "7f56",
	"./wolf/stock3.png": "9e81",
	"./wolf/stock4.png": "b118",
	"./wolf/stock5.png": "51f7",
	"./wolf/stock6.png": "1403",
	"./wolf/stock7.png": "d608",
	"./yoshi/avatar0.png": "b246",
	"./yoshi/avatar1.png": "7b73",
	"./yoshi/avatar2.png": "6dd1",
	"./yoshi/avatar3.png": "96c0",
	"./yoshi/avatar4.png": "6869",
	"./yoshi/avatar5.png": "0cdf",
	"./yoshi/avatar6.png": "12ac",
	"./yoshi/avatar7.png": "b3ed",
	"./yoshi/full0-min.png": "10fd",
	"./yoshi/full1-min.png": "f7c0",
	"./yoshi/full2-min.png": "25db",
	"./yoshi/full3-min.png": "5aa5",
	"./yoshi/full4-min.png": "2f4d",
	"./yoshi/full5-min.png": "9d0d",
	"./yoshi/full6-min.png": "b8e9",
	"./yoshi/full7-min.png": "c424",
	"./yoshi/selected0-min.png": "91f8",
	"./yoshi/selected1-min.png": "8458",
	"./yoshi/selected2-min.png": "ac09",
	"./yoshi/selected3-min.png": "80d3",
	"./yoshi/selected4-min.png": "eb34",
	"./yoshi/selected5-min.png": "4903",
	"./yoshi/selected6-min.png": "5b4d",
	"./yoshi/selected7-min.png": "e83d",
	"./yoshi/stock0.png": "56b5",
	"./yoshi/stock1.png": "6214",
	"./yoshi/stock2.png": "3f3a",
	"./yoshi/stock3.png": "baae",
	"./yoshi/stock4.png": "e0d5",
	"./yoshi/stock5.png": "d1a6",
	"./yoshi/stock6.png": "a0bb",
	"./yoshi/stock7.png": "d73d",
	"./young-link/avatar0.png": "7064",
	"./young-link/avatar1.png": "b8867",
	"./young-link/avatar2.png": "2215",
	"./young-link/avatar3.png": "4bf5",
	"./young-link/avatar4.png": "bfcc",
	"./young-link/avatar5.png": "63b0",
	"./young-link/avatar6.png": "60b1",
	"./young-link/avatar7.png": "181b",
	"./young-link/full0-min.png": "c593",
	"./young-link/full1-min.png": "3642",
	"./young-link/full2-min.png": "4491",
	"./young-link/full3-min.png": "6d68",
	"./young-link/full4-min.png": "2040",
	"./young-link/full5-min.png": "5ba1",
	"./young-link/full6-min.png": "5637",
	"./young-link/full7-min.png": "4655",
	"./young-link/selected0-min.png": "bcef",
	"./young-link/selected1-min.png": "3733",
	"./young-link/selected2-min.png": "a5dd",
	"./young-link/selected3-min.png": "2c53",
	"./young-link/selected4-min.png": "5e0c",
	"./young-link/selected5-min.png": "36b1",
	"./young-link/selected6-min.png": "f25a",
	"./young-link/selected7-min.png": "d1500",
	"./young-link/stock0.png": "83b6",
	"./young-link/stock1.png": "f6bd",
	"./young-link/stock2.png": "c0ba",
	"./young-link/stock3.png": "dd20",
	"./young-link/stock4.png": "9d47",
	"./young-link/stock5.png": "f13a",
	"./young-link/stock6.png": "23f0",
	"./young-link/stock7.png": "5c09",
	"./zelda/avatar0.png": "811a",
	"./zelda/avatar1.png": "fae9",
	"./zelda/avatar2.png": "2d89",
	"./zelda/avatar3.png": "3616",
	"./zelda/avatar4.png": "fc76",
	"./zelda/avatar5.png": "b777",
	"./zelda/avatar6.png": "953d6",
	"./zelda/avatar7.png": "f80f",
	"./zelda/full0-min.png": "1a19",
	"./zelda/full1-min.png": "0409",
	"./zelda/full2-min.png": "9a9d",
	"./zelda/full3-min.png": "43f8",
	"./zelda/full4-min.png": "66a3",
	"./zelda/full5-min.png": "b362",
	"./zelda/full6-min.png": "12e2",
	"./zelda/full7-min.png": "f014",
	"./zelda/selected0-min.png": "4854",
	"./zelda/selected1-min.png": "55c9",
	"./zelda/selected2-min.png": "f61c",
	"./zelda/selected3-min.png": "420c",
	"./zelda/selected4-min.png": "2583",
	"./zelda/selected5-min.png": "2ee2",
	"./zelda/selected6-min.png": "d482",
	"./zelda/selected7-min.png": "44de",
	"./zelda/stock0.png": "92b1",
	"./zelda/stock1.png": "1911",
	"./zelda/stock2.png": "fb48",
	"./zelda/stock3.png": "d760",
	"./zelda/stock4.png": "0e01",
	"./zelda/stock5.png": "c3d1",
	"./zelda/stock6.png": "9faa",
	"./zelda/stock7.png": "cc28",
	"./zero-suit-samus/avatar0.png": "2114",
	"./zero-suit-samus/avatar1.png": "debd",
	"./zero-suit-samus/avatar2.png": "498e",
	"./zero-suit-samus/avatar3.png": "03fd",
	"./zero-suit-samus/avatar4.png": "daef",
	"./zero-suit-samus/avatar5.png": "3688",
	"./zero-suit-samus/avatar6.png": "fd1d",
	"./zero-suit-samus/avatar7.png": "8f6e",
	"./zero-suit-samus/full0-min.png": "66aa",
	"./zero-suit-samus/full1-min.png": "fe74",
	"./zero-suit-samus/full2-min.png": "ef02",
	"./zero-suit-samus/full3-min.png": "4341",
	"./zero-suit-samus/full4-min.png": "88b2",
	"./zero-suit-samus/full5-min.png": "8c02",
	"./zero-suit-samus/full6-min.png": "417e",
	"./zero-suit-samus/full7-min.png": "90d0",
	"./zero-suit-samus/selected0-min.png": "51ae",
	"./zero-suit-samus/selected1-min.png": "b009",
	"./zero-suit-samus/selected2-min.png": "8795",
	"./zero-suit-samus/selected3-min.png": "0032",
	"./zero-suit-samus/selected4-min.png": "58d8",
	"./zero-suit-samus/selected5-min.png": "f2c7",
	"./zero-suit-samus/selected6-min.png": "b31d",
	"./zero-suit-samus/selected7-min.png": "d42d",
	"./zero-suit-samus/stock0.png": "70d90",
	"./zero-suit-samus/stock1.png": "855b",
	"./zero-suit-samus/stock2.png": "e16e",
	"./zero-suit-samus/stock3.png": "2a15",
	"./zero-suit-samus/stock4.png": "9a72",
	"./zero-suit-samus/stock5.png": "e117",
	"./zero-suit-samus/stock6.png": "1de2",
	"./zero-suit-samus/stock7.png": "c3f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36b19";